/**
 * reserva-estadias v1.2.3 (http://git.centralgest.com/develop/reserva-estadias)
 * Copyright 2020 Bruno Ferreira
 * Licensed under CentralGest, SA
 */
(function () {
  'use strict';

  var STEP_INDEX_START = 0;
  var STEP_INDEX_DATA = 1;
  var STEP_INDEX_DETAILS = 2;
  var STEP_INDEX_PAYMENT = 3;
  var STEP_INDEX_CONFIRMED = 4;

  angular.module('cgReservasEstadias', ['ngAnimate', 'angularMoment', 'jlareau.pnotify', 'ui.scrollpoint', 'ui.select', 'pl.comps'])
    .config(['plPromiseProvider', function (plPromiseProvider) {
      plPromiseProvider.setConfig({
        disableSpin: true
      });
    }])
    .component('cgReservasEstadias', {
      require: {
        ngModel: '?ngModel'
      },
      bindings: {
        sectionStartHeader: '<?',
        token: '@?'
      },
      templateUrl: '../source/cgReservasEstadias/cg-reservas-estadias.html',
      controllerAs: '$ctrl',
      controller: /*@ngInject*/ ['$window', '$q', '$timeout', '$state', '$filter', '$uibModal', 'moment', 'plFormat', '$interpolate', 'plAlertService', 'Lightbox', 'cgReservasEstadiasLocale', 'cgReservasEstadias', function ($window, $q, $timeout, $state, $filter, $uibModal, moment, plFormat, $interpolate, plAlertService, Lightbox, // jshint ignore:line
                                          cgReservasEstadiasLocale, cgReservasEstadias) {
        var ctrl = this;

        ctrl.locales = cgReservasEstadiasLocale.locales;
        ctrl.configurations = cgReservasEstadias.config();
        ctrl.templates = ctrl.configurations.templates;
        ctrl.format = plFormat.format;
        ctrl.fallback = ctrl.configurations.imageFallbackSource;
        ctrl.numberPattern = /^[0-9]*$/;

        ctrl.form = {};
        ctrl.model = {};
        ctrl.previousModel = null;
        ctrl.steps = {};
        ctrl.definition = {};
        ctrl.step = {};
        ctrl.plNavWizard = {};
        ctrl.affix = {};
        ctrl.step2Affix = {enabled: true};
        ctrl.promise = null;

        ctrl.typologies = [{idERTipoLocal: -1, nome: ctrl.locales.text.all}];
        ctrl.listaLocaisDisponiveis = [];
        ctrl.amounts = Object.freeze([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
        ctrl.paises = [];
        ctrl.selectedPais = null;
        ctrl.rowTemplatePaises = 'designacaoPT';
        ctrl.meiosPagamento = [];
        ctrl.empresa = {};
        ctrl.model = {};
        ctrl.consentimento = false;
        ctrl.finished = false;

        ctrl.$onInit = init;
        ctrl.render = render;
        ctrl.reset = reset;
        ctrl.beforeStepChange = beforeStepChange;
        ctrl.changedStep = changedStep;
        ctrl.submitForm = submitForm;
        ctrl.loadListaLocais = loadListaLocais;
        ctrl.evaluateListaLocais = evaluateListaLocais;
        ctrl.loadMeiosPagamento = loadMeiosPagamento;
        ctrl.loadEmpresa = loadEmpresa;
        ctrl.getImagemLocal = getImagemLocal;
        ctrl.getDetalhesLocal = getDetalhesLocal;
        ctrl.openGallery = openGallery;
        ctrl.generateAmount = generateAmount;
        ctrl.changedSelectedTypology = changedSelectedTypology;
        ctrl.isTodayEnabled = isTodayEnabled;
        ctrl.isStartDayEnabled = isStartDayEnabled;
        ctrl.isEndDayEnabled = isEndDayEnabled;
        ctrl.changedStartDate = changedStartDate;
        ctrl.changedEndDate = changedEndDate;
        ctrl.changedNumberOfPeople = changedNumberOfPeople;
        ctrl.changedNLocaisSelecionados = changedNLocaisSelecionados;
        ctrl.changedData = changedData;
        ctrl.changedConsentimento = changedConsentimento;
        ctrl.calculateTotals = calculateTotals;
        ctrl.marcarPreReserva = marcarPreReserva;
        ctrl.confirmarPreReserva = confirmarPreReserva;
        ctrl.confirmarReserva = confirmarReserva;
        ctrl.getPaises = getPaises;
        ctrl.getPaymentValue = getPaymentValue;
        ctrl.getPaymentLabel = getPaymentLabel;
        ctrl.changedPais = changedPais;
        ctrl.getNoLocationsAvailable = getNoLocationsAvailable;
        ctrl.getConfirmationDate = getConfirmationDate;
        ctrl.getCompanyIban = getCompanyIban;
        ctrl.doPrint = doPrint;
        ctrl.validMeioPagam = validMeioPagam;
        ctrl.validatorStep1 = validatorStep1;
        ctrl.validatorStep3 = validatorStep3;
        ctrl.getConsentimento = getConsentimento;
        ctrl.evaluateNDiasMinimoReserva = evaluateNDiasMinimoReserva;
        ctrl.finalize = finalize;

        /////////////

        function init() {
          ctrl.affix = {
            enabled: true
          };
          ctrl.definition = {
            items: [],
            force: false
          };
          ctrl.steps = [
            {
              caption: ctrl.locales.steps.start, name: 'step1', icon: 'fa-home', visible: true,
              templateUrl: '../source/cgReservasEstadias/steps/step1.start.html'
            },
            {
              caption: ctrl.locales.steps.data, name: 'step2', icon: 'fa-file-text', visible: true,
              templateUrl: '../source/cgReservasEstadias/steps/step2.data.html'
            },
            {
              caption: ctrl.locales.steps.details, name: 'step3', icon: 'fa-user', visible: true,
              templateUrl: '../source/cgReservasEstadias/steps/step3.details.html'
            },
            {
              caption: ctrl.locales.steps.payment, name: 'step4', icon: 'fa-credit-card', visible: true,
              templateUrl: '../source/cgReservasEstadias/steps/step4.payment.html'
            },
            {
              caption: ctrl.locales.steps.confirmed, name: 'step5', icon: 'fa-calendar-check-o', visible: false,
              templateUrl: '../source/cgReservasEstadias/steps/step5.confirmed.html'
            }
          ];
          ctrl.model = {
            identificacao: {
              idReservaCab: -1,
              pessoaReserva: null,
              emailReserva: null,
              nifReserva: null,
              contactoReserva: null,
              CodPais: null,
              observacoes: ''
            }
          };
          ctrl.loadMeiosPagamento();
          ctrl.loadEmpresa();
        }

        function render() {
          if (ctrl.ngModel) {
            ctrl.ngModel.$setViewValue(ctrl.model);
            ctrl.ngModel.$commitViewValue();
          }
        }

        function reset() {
          if (angular.isDefined(ctrl.model.identificacao.idReservaCab) && ctrl.model.identificacao.idReservaCab && ctrl.model.identificacao.idReservaCab !== -1) {
            ctrl.promise = cgReservasEstadias.apagarPreReserva(ctrl.model.identificacao.idReservaCab).then()['finally'](function () {
              ctrl.promise = null;
            });
          }
          $q.when(ctrl.promise).then()['finally'](function () {
            ctrl.typologies = [];
            ctrl.listaLocaisDisponiveis = [];
            ctrl.paises = [];
            ctrl.selectedPais = null;
            ctrl.model = {
              typology: null,
              startDate: moment().toISOString(),
              endDate: moment().add(1, 'days').toISOString(),
              total: 0,
              totalAdults: 0,
              totalChilds: 0,
              identificacao: {
                idReservaCab: -1,
                pessoaReserva: null,
                contactoReserva: null,
                emailReserva: null,
                CodPais: null
              },
              meiopagam: undefined,
              codReservaGerada: null,
              locais: [],
              local: {},
              confirmacao: {
                codReservaGerada: null,
                faccbIDDocAdiantamento: null,
                idReservaCab: null
              }
            };
            ctrl.definition.items[STEP_INDEX_START].complete = false;
            ctrl.definition.items[STEP_INDEX_DATA].complete = false;
            ctrl.definition.items[STEP_INDEX_DETAILS].complete = false;
            ctrl.definition.items[STEP_INDEX_PAYMENT].complete = false;
            ctrl.finished = false;
          });
        }

        function beforeStepChange(currentStep, previousStep, type, nextStep) {
          if (!ctrl.finished) {
            if (currentStep === ctrl.definition.items[STEP_INDEX_DATA] && type !== 'previous' && previousStep !== nextStep) {
              return ctrl.validatorStep1(currentStep, previousStep);
            } else if (currentStep === ctrl.definition.items[STEP_INDEX_DETAILS]) {
              return ctrl.validatorStep3(currentStep, previousStep, type, nextStep).then(
                function () {
                  if (previousStep === ctrl.definition.items[STEP_INDEX_DATA]) {
                    ctrl.loadMeiosPagamento();
                  }
                  return true;
                },
                function () {
                  plAlertService.error(ctrl.locales.errors.rgpdConsent);
                  return false;
                }
              );
            } else if (currentStep === ctrl.definition.items[STEP_INDEX_PAYMENT] && (!type || type === 'next') &&
              (!nextStep || nextStep === ctrl.definition.items[STEP_INDEX_CONFIRMED])) {
              ctrl.confirmarReserva();
            }
          }
        }

        function changedStep(currentStep, previousStep) {
          if (!ctrl.finished) {
            if (currentStep === ctrl.definition.items[STEP_INDEX_START]) {
              if (previousStep !== ctrl.definition.items[STEP_INDEX_PAYMENT]) {
                ctrl.reset();
              }
              var typologies;
              ctrl.promise = cgReservasEstadias.tiposLocaisReservas().then(function (response) {
                typologies = response.data.list;
              })['finally'](function () {
                ctrl.promise = null;
                ctrl.typologies = [{idERTipoLocal: -1, nome: ctrl.locales.text.all}];
                if (angular.isArray(typologies)) {
                  ctrl.typologies = typologies.concat(ctrl.typologies);
                }
              });
            } else if (currentStep === ctrl.definition.items[STEP_INDEX_DATA]) {
              if (previousStep === ctrl.definition.items[STEP_INDEX_START]) {
                ctrl.loadListaLocais();
              } else {
                ctrl.evaluateListaLocais();
              }
            } else if (previousStep === ctrl.definition.items[STEP_INDEX_DATA] && currentStep === ctrl.definition.items[STEP_INDEX_DETAILS]) {
              ctrl.getPaises();
              ctrl.marcarPreReserva();
            } else if (previousStep === ctrl.definition.items[STEP_INDEX_DETAILS] && currentStep === ctrl.definition.items[STEP_INDEX_PAYMENT]) {
              ctrl.confirmarPreReserva();
            }
          }
        }

        function submitForm() {
          ctrl.forms[ctrl.step.name].$setSubmitted();
          ctrl.plNavWizard.nextStep();
        }

        function loadListaLocais() {
          ctrl.promise = cgReservasEstadias.locaisDisponiveis(ctrl.model.typology, ctrl.model.startDate, ctrl.model.endDate).then(function (response) {
            ctrl.listaLocaisDisponiveis = response.data;
            angular.forEach(ctrl.listaLocaisDisponiveis, function (localDisponivel) {
              localDisponivel._promise = null;
              localDisponivel._hasError = false;
              localDisponivel._invalidMaxNumberOfPeople = false;
              localDisponivel.amounts = ctrl.generateAmount(localDisponivel);
              localDisponivel.model = _.merge({}, {
                IdReservaCab: undefined,
                NLocaisSelecionados: 0,
                NAdultos: 0,
                NCriancas: 0,
                DataInicio: ctrl.model.startDate,
                DataFim: ctrl.model.endDate,
                precoUnitLocal: localDisponivel.precoUnitLocal
              }, localDisponivel);
              ctrl.evaluateNDiasMinimoReserva(localDisponivel);
              return ctrl.getDetalhesLocal(localDisponivel);
            });
          })['finally'](function () {
            ctrl.promise = null;
          });
        }

        function evaluateListaLocais() {
          angular.forEach(ctrl.listaLocaisDisponiveis, function (localDisponivel) {
            ctrl.changedNumberOfPeople(localDisponivel);
            ctrl.changedNLocaisSelecionados(localDisponivel);
          });
        }

        function loadMeiosPagamento() {
          if (!ctrl.meiosPagamento.length) {
            ctrl.paymentPromise = cgReservasEstadias.meiosPagamento().then(function (response) {
              ctrl.meiosPagamento = response.data;
            })['finally'](function () {
              ctrl.paymentPromise = null;
            });
          }
        }

        function loadEmpresa() {
          ctrl.promise = cgReservasEstadias.empresa().then(function (response) {
            ctrl.empresa = response.data;
          })['finally'](function () {
            ctrl.promise = null;
          });
        }

        function getImagemLocal(local, imagens) {
          if (angular.isArray(imagens) && imagens.length) {
            return cgReservasEstadias.imagemDoLocal(local, imagens[0].docId);
          }
          return '';
        }

        function getDetalhesLocal(local) {
          if (!local._promise && angular.isArray(local.informacao) && local.informacao.length) {
            var promises = [];
            for (var i = 0; i < local.informacao.length; i++) {
              var informacao = local.informacao[i];
              promises.push(cgReservasEstadias.descricaoLocal(local.idErLocal, informacao.docId));
            }
            local._promise = $q.all(promises).then(function (response) {
              var descricao = [];
              for (var j = 0; j < response.length; j++) {
                var list = response[j].data.list;
                for (var z = 0; z < list.length; z++) {
                  descricao.push(list[z].dados);
                }
              }
              local._descricao = descricao;
            })['finally'](function () {
              local._promise = null;
            });
          }
        }

        function openGallery(idLocal, imagens, index) {
          var sources = imagens.map(function (item) {
            return cgReservasEstadias.imagemDoLocal(idLocal, item.docId);
          });
          Lightbox.openModal(sources, index || 0, {
            controllerAs: '$ctrl',
            controller: /*@ngInject*/ ['Lightbox', 'cgReservasEstadias', function (Lightbox, cgReservasEstadias) {
              var ctrl = this;
              ctrl.locales = cgReservasEstadiasLocale.locales;
              ctrl.lightbox = Lightbox;
              ctrl.fallback = cgReservasEstadias.config().imageFallbackSource;
              Lightbox.keyboardNavEnabled = true;
            }]
          });
        }

        function generateAmount(local) {
          var amounts = [];
          for (var i = 0; i <= local.nLocaisDisponiveis; i++) {
            amounts.push(i);
          }
          return amounts;
        }

        function changedSelectedTypology(plEditSelect, plEditSelectFormCtrl, value, selected) {
          ctrl.model.selectedTypology = selected;
        }

        function isTodayEnabled(date) {
          return date.isSameOrAfter(moment());
        }

        function isStartDayEnabled(day) {
          return day.isAfter(moment());
        }

        function isEndDayEnabled(day) {
          return day.isAfter(moment(ctrl.model.startDate));
        }

        function changedStartDate() {
          ctrl.model.endDate = moment(ctrl.model.startDate).add(1, 'days').toISOString();
          ctrl.changedEndDate();
        }

        function changedEndDate() {
          ctrl.loadListaLocais();
        }

        function changedNumberOfPeople(item) {
          if (ctrl.finished) {
            return;
          }
          item._peopleCount = item.model.NAdultos + item.model.NCriancas;
          item.model.precoUnitLocal = item.precoUnitLocal;
          if (angular.isArray(item.localPrecos)) {
            for (var i = item.localPrecos.length - 1; i >= 0; i--) {
              var localPreco = item.localPrecos[i];
              if (localPreco.nPessoas === item._peopleCount) {
                item.model.precoUnitLocal = localPreco.precoLocal;
                break;
              }
            }
          }
          ctrl.changedData(item);
        }

        function changedNLocaisSelecionados(item) {
          if (ctrl.finished) {
            return;
          }
          if (!item.model.NLocaisSelecionados) {
            item.model.NAdultos = 0;
            item.model.NCriancas = 0;
          }
          ctrl.changedData(item);
        }

        function changedData(item) {
          if (ctrl.finished) {
            return;
          }
          item._hasError = false;
          item._peopleCount = item.model.NAdultos + item.model.NCriancas;
          if (item.model.NLocaisSelecionados) {
            if (item.nmaxPessoasLocal) {
              item._invalidMaxNumberOfPeople = !item.model.NAdultos || item._peopleCount > item.nmaxPessoasLocal;
              if (item._invalidMaxNumberOfPeople) {
                item._hasError = true;
              }
            }
            ctrl.evaluateNDiasMinimoReserva(item);
            if (item._invalidNDiasMinimoReserva) {
              item._hasError = true;
            }
          } else {
            item._invalidMaxNumberOfPeople = false;
            item._invalidNDiasMinimoReserva = false;
          }
          ctrl.definition.items[STEP_INDEX_DATA].complete = false;
          ctrl.calculateTotals();
        }

        function changedConsentimento() {
          ctrl.definition.items[STEP_INDEX_DETAILS].complete = false;
        }

        function calculateTotals() {
          ctrl.model.total = 0;
          ctrl.model.totalAdults = 0;
          ctrl.model.totalChilds = 0;
          angular.forEach(ctrl.listaLocaisDisponiveis, function (localDisponivel) {
            if (angular.isObject(localDisponivel) && angular.isObject(localDisponivel.model)) {
              var nLocaisSelecionados = localDisponivel.model.NLocaisSelecionados || 0;
              ctrl.model.total += localDisponivel.model.precoUnitLocal * nLocaisSelecionados;
              if (nLocaisSelecionados) {
                ctrl.model.totalAdults += localDisponivel.model.NAdultos;
                ctrl.model.totalChilds += localDisponivel.model.NCriancas;
              }
            }
          });
        }

        function marcarPreReserva() {
          function findLocal(idErLocal) {
            return function (local) {
              return local.idErLocal === idErLocal;
            };
          }

          var promise = null;
          if (ctrl.promise) {
            promise = ctrl.promise;
          }
          $q.when(promise).then()['finally'](function () {
            if (!ctrl.previousModel || !angular.equals(ctrl.model, ctrl.previousModel)) {
              ctrl.model.locais = [];
              angular.forEach(ctrl.listaLocaisDisponiveis, function (localDisponivel) {
                if (angular.isObject(localDisponivel.model) && localDisponivel.model.NLocaisSelecionados) {
                  ctrl.model.locais.push(localDisponivel.model);
                  if (localDisponivel.IdReservaCab || localDisponivel.IdReservaCab === 0) {
                    ctrl.model.identificacao.idReservaCab = localDisponivel.IdReservaCab;
                  }
                }
              });
              ctrl.model.local = ctrl.model.locais[0];
              ctrl.promise = cgReservasEstadias.marcarPreReserva(ctrl.model.locais, ctrl.model.identificacao.idReservaCab).then(
                function (response) {
                  ctrl.previousModel = angular.copy(ctrl.model);
                  ctrl.model.locais = response.data;
                  if (angular.isArray(ctrl.model.locais) && ctrl.model.locais.length) {
                    ctrl.model.identificacao.idReservaCab = ctrl.model.locais[0].idReservaCab;
                  }
                  for (var i = 0; i < ctrl.listaLocaisDisponiveis.length; i++) {
                    var localDisponivel = ctrl.listaLocaisDisponiveis[i];
                    var local = _.find(ctrl.model.locais, findLocal(localDisponivel.idErLocal));
                    if (angular.isDefined(local)) {
                      angular.extend(ctrl.listaLocaisDisponiveis[i], local);
                    }
                  }
                  ctrl.model.local = ctrl.model.locais[0];
                }
              )['finally'](function () {
                ctrl.promise = null;
              });
            }
          });
        }

        function confirmarPreReserva() {
          var identificacao = angular.copy(ctrl.model.identificacao);
          if (identificacao.nifReserva) {
            if (!identificacao.observacoes) {
              identificacao.observacoes = '';
            }
            identificacao.observacoes = 'NIF: ' + identificacao.nifReserva + '; ' + identificacao.observacoes;
          }
          ctrl.promise = cgReservasEstadias.confirmarPreReserva(identificacao.idReservaCab, identificacao)['finally'](function () {
            ctrl.promise = null;
          });
        }

        function confirmarReserva() {
          if (ctrl.model.identificacao.idReservaCab >= 0 && ctrl.model.meiopagam >= 0) {
            ctrl.summaryPromise = cgReservasEstadias.confirmarReserva(ctrl.model.identificacao.idReservaCab, ctrl.model.meiopagam).then(function (response) {
              ctrl.finished = true;
              ctrl.model.confirmacao = response.data.data;
              ctrl.definition.items[STEP_INDEX_CONFIRMED].visible = ctrl.definition.items[STEP_INDEX_CONFIRMED].complete = true;
              $timeout(function () {
                ctrl.model.identificacao.idReservaCab = -1;
                ctrl.model.confirmacao.idReservaCab = -1;

                plAlertService.success(ctrl.locales.text.sentConfirmationEmail, {delay: 6000});
                ctrl.plNavWizard.nextStep();
              });
            })['finally'](function () {
              ctrl.summaryPromise = null;
            });
          } else {
            if (ctrl.model.identificacao.idReservaCab < 0) {
              plAlertService.warning(ctrl.locales.errors.invalidIdReserva);
            } else if (ctrl.model.meiopagam < 0) {
              plAlertService.warning(ctrl.locales.errors.invalidMeioPagam);
            }
          }
        }

        function getPaises() {
          return cgReservasEstadias.paises().then(function (response) {
            ctrl.paises = response.data.list || response.data;
            ctrl.selectedPais = ctrl.paises.find(function (pais) {
              return pais.codigoAlpha3 === 'PRT';
            });
            ctrl.model.identificacao.CodPais = ctrl.selectedPais.codigo;
          });
        }

        function getPaymentValue(item) {
          return item.ncaixa || item.value;
        }

        function getPaymentLabel(item) {
          return item.nome || ctrl.locales.form[item.caption];
        }

        function changedPais(data) {
          if (data && data.item) {
            ctrl.model.identificacao.CodPais = data.item.codigo;
          }
        }

        function getNoLocationsAvailable() {
          var startDate = $filter('date')(ctrl.model.startDate, ctrl.format.date);
          var endDate = $filter('date')(ctrl.model.endDate, ctrl.format.date);
          return $interpolate(ctrl.locales.text.noLocationsAvailable)({startDate: startDate, endDate: endDate});
        }

        function getConfirmationDate(value, format) {
          return moment(value).format(format);
        }

        function getCompanyIban() {
          var pagam = ctrl.meiosPagamento.find(function (meiopagam) {
            return meiopagam.ncaixa === ctrl.model.meiopagam;
          });
          if (angular.isObject(pagam) && pagam.nib) {
            var nib = pagam.nib.match(/.{1,4}/g);
            if (nib) {
              return nib.join(' ');
            }
            return pagam.nib;
          }
          return ctrl.locales.text.selectPaymentIban;
        }

        function doPrint() {
          return $window.print();
        }

        function validMeioPagam() {
          return angular.isDefined(ctrl.model.meiopagam) && ctrl.model.meiopagam !== null;
        }

        function validatorStep1() {
          var i;
          var toCheck = [];
          for (i = 0; i < ctrl.listaLocaisDisponiveis.length; i++) {
            var localDisponivel = ctrl.listaLocaisDisponiveis[i];
            if (localDisponivel.model.NLocaisSelecionados) {
              toCheck.push(localDisponivel);
            } else {
              localDisponivel._hasError = false;
            }
          }
          if (!toCheck.length) {
            plAlertService.warning(ctrl.locales.errors.invalidLocationsQty);
            return false;
          }

          var localSelecionado;
          var errors = [];
          for (i = 0; i < toCheck.length; i++) {
            localSelecionado = toCheck[i];
            if (!localSelecionado.model.NAdultos && !localSelecionado.model.NCriancas) {
              localSelecionado._hasError = true;
              errors.push(localSelecionado.model.nome);
            } else {
              localSelecionado._hasError = false;
            }
          }
          if (errors.length) {
            plAlertService.error($interpolate(ctrl.locales.errors.invalidLocationsNPeople)({locations: errors.join(', ')}));
            return false;
          }

          errors = [];
          for (i = 0; i < toCheck.length; i++) {
            localSelecionado = toCheck[i];
            if (!localSelecionado.model.NAdultos) {
              localSelecionado._hasError = true;
              errors.push(localSelecionado.model.nome);
            } else {
              localSelecionado._hasError = false;
            }
          }
          if (errors.length) {
            plAlertService.error($interpolate(ctrl.locales.errors.invalidLocationsNAdults)({locations: errors.join(', ')}));
            return false;
          }

          errors = [];
          for (i = 0; i < toCheck.length; i++) {
            localSelecionado = toCheck[i];
            if (localSelecionado.nmaxPessoasLocal) {
              localSelecionado._peopleCount = localSelecionado.model.NAdultos + localSelecionado.model.NCriancas;
              localSelecionado._hasError = localSelecionado.model.NLocaisSelecionados && localSelecionado._peopleCount > localSelecionado.nmaxPessoasLocal;
              if (localSelecionado._hasError) {
                errors.push(localSelecionado.model.nome);
              }
            }
          }
          if (errors.length) {
            plAlertService.error($interpolate(ctrl.locales.errors.invalidMaxNumberOfPeople)({locations: errors.join(', ')}));
            return false;
          }

          errors = [];
          for (i = 0; i < toCheck.length; i++) {
            localSelecionado = toCheck[i];
            localSelecionado._peopleCount = localSelecionado.model.NAdultos + localSelecionado.model.NCriancas;
            ctrl.evaluateNDiasMinimoReserva(localSelecionado);
            localSelecionado._hasError = localSelecionado._invalidNDiasMinimoReserva && localSelecionado.model.NLocaisSelecionados;
            if (localSelecionado._hasError) {
              errors.push(localSelecionado.model.nome);
            }
          }
          if (errors.length) {
            plAlertService.error($interpolate(ctrl.locales.errors.invalidMinNumberOfDays)({locations: errors.join(', ')}));
            return false;
          }

          return true;
        }

        function validatorStep3(currentStep, previousStep, type, nextStep) {
          var deferred = $q.defer();
          if (type && type === 'previous' || nextStep && nextStep !== ctrl.definition.items[STEP_INDEX_PAYMENT] && nextStep !== ctrl.definition.items[STEP_INDEX_PAYMENT]) {
            deferred.resolve(true);
          } else if (ctrl.consentimento) {
            deferred.resolve(ctrl.consentimento);
          } else {
            deferred.reject(ctrl.consentimento);
          }
          return deferred.promise;
        }

        function getConsentimento() {
          return $uibModal.open({
            size: 'lg',
            templateUrl: ctrl.templates.rgpdTerms,
            bindToController: true,
            controllerAs: '$ctrl',
            controller: /*@ngInject*/ ['cgReservasEstadiasLocale', 'cgReservasEstadias', function (cgReservasEstadiasLocale, cgReservasEstadias) {
              var ctrl = this;
              ctrl.locales = cgReservasEstadiasLocale.locales;
              ctrl.rgpdTermsBody = cgReservasEstadias.config().templatesHTML.rgpdTermsBody;
            }]
          }).result;
        }

        function evaluateNDiasMinimoReserva(item) {
          item._invalidNDiasMinimoReserva = false;
          if (item.nDiasMinimoReserva) {
            var startDate = moment(ctrl.model.startDate).startOf('day');
            var endDate = moment(ctrl.model.endDate).startOf('day');
            var daysDifference = moment.duration(moment(endDate).diff(startDate)).asDays();
            item._invalidNDiasMinimoReserva = daysDifference < item.nDiasMinimoReserva;
          }
        }

        function finalize() {
          return $state.reload();
        }
      }]
    })
    .filter('cgreTranslate', ['$interpolate', function ($interpolate) {
      return function (key, params) {
        if (params && angular.isObject(params)) {
          return $interpolate(key)(params);
        }
        return key;
      };
    }]);
})();
(function(){'use strict';angular.module('cgReservasEstadias').run(['$templateCache', function($templateCache) {$templateCache.put('../source/cgReservasEstadias/cg-reservas-estadias.html','<div class="cg-reservas-estadias">\r\n  <pl-form name="$ctrl.form" properties="{disabled: $ctrl.finished}">\r\n    <pl-nav-wizard ng-model="$ctrl.step"\r\n                   definition="$ctrl.definition"\r\n                   callback="$ctrl.plNavWizard"\r\n                   before-step-change="$ctrl.beforeStepChange(currentStep, previousStep, type, nextStep)"\r\n                   on-step-change="$ctrl.changedStep(currentStep, previousStep, type)"\r\n                   affix="$ctrl.affix"\r\n                   hide-footer="true">\r\n      <pl-nav-wizard-step caption="{{$ctrl.steps[0].caption}}" name="{{$ctrl.steps[0].name}}" icon="{{$ctrl.steps[0].icon}}" visible="$ctrl.steps[0].visible">\r\n        <div ng-include="$ctrl.steps[0].templateUrl"></div>\r\n      </pl-nav-wizard-step>\r\n\r\n      <pl-nav-wizard-step caption="{{$ctrl.steps[1].caption}}" name="{{$ctrl.steps[1].name}}" icon="{{$ctrl.steps[1].icon}}" visible="$ctrl.steps[1].visible"\r\n                          validator="$ctrl.validatorStep1(toStep, currentStep, previousStep)">\r\n        <div ng-include="$ctrl.steps[1].templateUrl"></div>\r\n      </pl-nav-wizard-step>\r\n\r\n      <pl-nav-wizard-step caption="{{$ctrl.steps[2].caption}}" name="{{$ctrl.steps[2].name}}" icon="{{$ctrl.steps[2].icon}}" visible="$ctrl.steps[2].visible">\r\n        <div ng-include="$ctrl.steps[2].templateUrl"></div>\r\n      </pl-nav-wizard-step>\r\n\r\n      <pl-nav-wizard-step caption="{{$ctrl.steps[3].caption}}" name="{{$ctrl.steps[3].name}}" icon="{{$ctrl.steps[3].icon}}" visible="$ctrl.steps[3].visible">\r\n        <div ng-include="$ctrl.steps[3].templateUrl"></div>\r\n      </pl-nav-wizard-step>\r\n\r\n      <pl-nav-wizard-step caption="{{$ctrl.steps[4].caption}}" name="{{$ctrl.steps[4].name}}" icon="{{$ctrl.steps[4].icon}}" visible="$ctrl.steps[4].visible">\r\n        <div ng-include="$ctrl.steps[4].templateUrl"></div>\r\n      </pl-nav-wizard-step>\r\n    </pl-nav-wizard>\r\n  </pl-form>\r\n</div>\r\n');
$templateCache.put('../source/cgReservasEstadias/steps/step1.start.html','<div class="cg-reservas-estadias-step cg-reservas-estadias-start" pl-promise="$ctrl.promise" promise-btn-options="{dim: true}">\r\n  <div class="row">\r\n    <div class="col-xs-12" ng-bind-html="$ctrl.sectionStartHeader"></div>\r\n  </div>\r\n\r\n  <pl-form name="$ctrl.forms.step1" properties="{orientation: \'vertical\', disabled: $ctrl.finished, validators: {required: {value: true}}}">\r\n    <div class="row">\r\n      <div class="col-xs-12 col-md-4 input-start">\r\n        <pl-group>\r\n          <label>{{$ctrl.locales.text.typology}}</label>\r\n          <edit>\r\n            <pl-edit type="select" ng-model="$ctrl.model.typology" properties="{select: {valueProp: \'idERTipoLocal\', labelProp: \'nome\', list: $ctrl.typologies},\r\n            events: {change: $ctrl.changedSelectedTypology}}">\r\n            </pl-edit>\r\n          </edit>\r\n        </pl-group>\r\n      </div>\r\n\r\n      <div class="col-xs-12 col-md-3 input-start">\r\n        <pl-group>\r\n          <label>{{$ctrl.locales.text.startDate}}</label>\r\n          <edit>\r\n            <pl-edit type="date" ng-model="$ctrl.model.startDate" ng-change="$ctrl.changedStartDate()" properties="{dayEnabled: $ctrl.isStartDayEnabled}"></pl-edit>\r\n          </edit>\r\n        </pl-group>\r\n      </div>\r\n\r\n      <div class="col-xs-12 col-md-3 input-start">\r\n        <pl-group>\r\n          <label>{{$ctrl.locales.text.endDate}}</label>\r\n          <edit>\r\n            <pl-edit type="date" ng-model="$ctrl.model.endDate" properties="{todayEnabled: $ctrl.isTodayEnabled, dayEnabled: $ctrl.isEndDayEnabled}"></pl-edit>\r\n          </edit>\r\n        </pl-group>\r\n      </div>\r\n\r\n      <div class="col-xs-12 col-md-2 btn-next">\r\n        <pl-group>\r\n          <edit>\r\n            <button type="button" class="btn btn-primary btn-block" ng-click="$ctrl.submitForm()">\r\n              {{$ctrl.locales.text.next}} <i class="fa fa-arrow-right fa-fw" aria-hidden="true"></i>\r\n            </button>\r\n          </edit>\r\n        </pl-group>\r\n      </div>\r\n    </div>\r\n  </pl-form>\r\n</div>\r\n');
$templateCache.put('../source/cgReservasEstadias/steps/step2.data.html','<div class="cg-reservas-estadias-step">\r\n  <pl-form name="$ctrl.forms.step2" on-submit="$ctrl.plNavWizard.nextStep()"\r\n           properties="{disabled: $ctrl.finished, validators: {required: {value: true, message: \'\'}}}">\r\n    <div class="cg-reservas-estadias-data">\r\n      <div class="row">\r\n        <div class="col-md-3">\r\n          <ng-include src="$ctrl.templates.information"></ng-include>\r\n        </div>\r\n\r\n        <div class="col-md-6">\r\n          <div pl-promise="$ctrl.promise">\r\n            <div ng-if="!$ctrl.promise && $ctrl.listaLocaisDisponiveis.length">\r\n              <div class="cg-reservas-estadias-data-type" ng-repeat="type in $ctrl.listaLocaisDisponiveis track by type.idErLocal"\r\n                   ng-class="{\'active\': type.model.NLocaisSelecionados, \'has-error\': type._hasError}" ng-include="$ctrl.templates.dataItem">\r\n              </div>\r\n            </div>\r\n\r\n            <div ng-if="!$ctrl.promise && !$ctrl.listaLocaisDisponiveis.length">\r\n              <h5 ng-bind-html="$ctrl.getNoLocationsAvailable()"></h5>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class="col-md-3">\r\n          <ng-include src="$ctrl.templates.summary"></ng-include>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </pl-form>\r\n</div>\r\n');
$templateCache.put('../source/cgReservasEstadias/steps/step3.details.html','<div class="cg-reservas-estadias-step cg-reservas-estadias-details" pl-promise="$ctrl.promise">\r\n  <pl-form name="$ctrl.forms.step3" properties="{disabled: $ctrl.finished, validators: {required: {value: true}}}">\r\n    <div class="row">\r\n      <div class="col-sm-12 col-md-6 col-lg-8">\r\n        <div class="cg-reservas-estadias-data">\r\n          <div class="cg-reservas-estadias-data-detail">\r\n            <div class="cg-reservas-estadias-heading">\r\n              <span class="summary-heading">{{$ctrl.locales.titles.reservationData}}</span>\r\n            </div>\r\n            <div class="cg-reservas-estadias-body">\r\n              <pl-group>\r\n                <label>{{$ctrl.locales.form.name}}</label>\r\n                <edit>\r\n                  <pl-edit type="text" ng-model="$ctrl.model.identificacao.pessoaReserva"></pl-edit>\r\n                </edit>\r\n              </pl-group>\r\n\r\n              <pl-group>\r\n                <label>{{$ctrl.locales.form.country}}</label>\r\n                <edit>\r\n                  <pl-edit type="select2" ng-model="$ctrl.selectedPais" properties="{source: $ctrl.paises, rowTemplate: $ctrl.rowTemplatePaises,\r\n                      output: $ctrl.rowTemplatePaises, onChange: $ctrl.changedPais, forceFixEvents: true}">\r\n                  </pl-edit>\r\n                </edit>\r\n              </pl-group>\r\n\r\n              <pl-group>\r\n                <label>{{$ctrl.locales.form.email}}</label>\r\n                <edit>\r\n                  <pl-edit type="email" ng-model="$ctrl.model.identificacao.emailReserva"></pl-edit>\r\n                </edit>\r\n              </pl-group>\r\n\r\n              <pl-group>\r\n                <label>{{$ctrl.locales.form.nif}}</label>\r\n                <edit>\r\n                  <pl-edit type="text"\r\n                           ng-model="$ctrl.model.identificacao.nifReserva"\r\n                           properties="{validators: {pattern: {value: $ctrl.numberPattern}, minlength: {value: 9}, maxlength: {value: 9}}}">\r\n                  </pl-edit>\r\n                </edit>\r\n              </pl-group>\r\n\r\n              <pl-group>\r\n                <label>{{$ctrl.locales.form.phoneNumber}}</label>\r\n                <edit>\r\n                  <pl-edit type="text" ng-model="$ctrl.model.identificacao.contactoReserva"\r\n                           properties="{validators: {pattern: {value: $ctrl.numberPattern}, minlength: {value: 9}, maxlength: {value: 9}}}">\r\n                  </pl-edit>\r\n                </edit>\r\n              </pl-group>\r\n\r\n              <pl-group properties="{validators: {required: {value: false}}}">\r\n                <label>{{$ctrl.locales.form.observations}}</label>\r\n                <edit>\r\n                  <pl-edit type="textarea" ng-model="$ctrl.model.identificacao.observacoes"></pl-edit>\r\n                </edit>\r\n              </pl-group>\r\n\r\n              <pl-group>\r\n                <label>{{$ctrl.locales.form.rgpd}}</label>\r\n                <edit>\r\n                  <pl-edit type="checkbox" ng-model="$ctrl.consentimento" ng-change="$ctrl.changedConsentimento()"></pl-edit>\r\n                  <span class="pl-edit-cell">\r\n                    <span>{{$ctrl.locales.text.rgpd1}}</span>\r\n                    <span ng-click="$ctrl.getConsentimento()"><u>{{$ctrl.locales.text.rgpd2}}</u></span>\r\n                    <span>{{$ctrl.locales.text.rgpd3}}</span>\r\n                  </span>\r\n                </edit>\r\n              </pl-group>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class="col-sm-12 col-md-6 col-lg-4">\r\n        <div class="cg-reservas-estadias-data">\r\n          <ng-include src="$ctrl.templates.summary"></ng-include>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </pl-form>\r\n</div>\r\n');
$templateCache.put('../source/cgReservasEstadias/steps/step4.payment.html','<div class="cg-reservas-estadias-step cg-reservas-estadias-payment" pl-promise="$ctrl.promise">\r\n  <pl-form name="$ctrl.forms.step4" properties="{disabled: $ctrl.finished, validators: {required: {value: true}}}">\r\n    <div class="row">\r\n      <div class="col-sm-12 col-md-6 col-lg-4">\r\n        <div class="cg-reservas-estadias-payment-method" pl-promise="$ctrl.paymentPromise">\r\n          <div class="cg-reservas-estadias-heading">\r\n            <span class="summary-title">{{$ctrl.locales.form.paymentMethod}}</span>\r\n          </div>\r\n          <div class="cg-reservas-estadias-body">\r\n            <pl-group properties="{labelClass: \'\', editClass: \'col-sm-12\', hideActions: true}" ng-repeat="item in $ctrl.meiosPagamento"\r\n                      ng-class="{\'hidden-print\': $ctrl.model.meiopagam !== $ctrl.getPaymentValue(item)}">\r\n              <edit>\r\n                <div class="cg-reservas-estadias-payment-item" ng-click="$ctrl.model.meiopagam = $ctrl.getPaymentValue(item)">\r\n                  <pl-edit type="radio" ng-model="$ctrl.model.meiopagam" properties="{value: $ctrl.getPaymentValue(item), label: $ctrl.getPaymentLabel(item)}"></pl-edit>\r\n                </div>\r\n              </edit>\r\n            </pl-group>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class="col-sm-12 col-md-6 col-lg-8">\r\n        <ng-include src="$ctrl.templates.summary"></ng-include>\r\n      </div>\r\n    </div>\r\n  </pl-form>\r\n</div>\r\n');
$templateCache.put('../source/cgReservasEstadias/steps/step5.confirmed.html','<div class="cg-reservas-estadias-step cg-reservas-estadias-confirmed" pl-promise="$ctrl.promise">\r\n  <pl-form name="$ctrl.forms.step5" properties="{disabled: $ctrl.finished, validators: {required: {value: true}}}">\r\n    <div class="cg-reservas-estadias-heading hidden-print">\r\n      <span class="summary-title">{{$ctrl.locales.titles.confirmed}}</span>\r\n    </div>\r\n    <div class="cg-reservas-estadias-heading visible-print">\r\n      <span class="summary-title">{{$ctrl.locales.titles.confirmedPrint}}</span>\r\n    </div>\r\n    <div class="cg-reservas-estadias-body">\r\n      <div class="hidden-print">\r\n        <button type="button" class="btn btn-success pull-right" ng-click="$ctrl.finalize()" pl-promise>\r\n          <i class="fa fa-repeat" aria-hidden="true"></i>&nbsp;<span>{{$ctrl.locales.text.finalize}}</span>\r\n        </button>\r\n\r\n        <button type="button" class="btn btn-primary" ng-click="$ctrl.doPrint()" pl-promise>\r\n          <i class="fa fa-print" aria-hidden="true"></i>&nbsp;<span>{{$ctrl.locales.text.print}}</span>\r\n        </button>\r\n      </div>\r\n\r\n      <hr class="hidden-print">\r\n\r\n      <dl class="dl-horizontal">\r\n        <dt>{{$ctrl.locales.form.name}}:</dt>\r\n        <dd>{{$ctrl.model.identificacao.pessoaReserva}}</dd>\r\n\r\n        <dt>{{$ctrl.locales.form.country}}:</dt>\r\n        <dd>{{$ctrl.selectedPais[$ctrl.rowTemplatePaises]}}</dd>\r\n\r\n        <dt>{{$ctrl.locales.form.email}}:</dt>\r\n        <dd>{{$ctrl.model.identificacao.emailReserva}}</dd>\r\n\r\n        <dt>{{$ctrl.locales.form.phoneNumber}}:</dt>\r\n        <dd>{{$ctrl.model.identificacao.contactoReserva}}</dd>\r\n      </dl>\r\n\r\n      <hr>\r\n\r\n      <dl class="dl-horizontal">\r\n        <dt>{{$ctrl.locales.text.iban}}:</dt>\r\n        <dd>{{$ctrl.getCompanyIban()}}</dd>\r\n      </dl>\r\n\r\n      <dl class="dl-horizontal">\r\n        <dt>{{$ctrl.locales.form.confirmation}}:</dt>\r\n        <dd><span class="label label-success">{{$ctrl.model.confirmacao.codReservaGerada}}</span></dd>\r\n      </dl>\r\n\r\n      <hr>\r\n\r\n      <div class="cg-reservas-estadias-confirmed-warning" ng-bind-html="$ctrl.locales.text.confirmedWarning"></div>\r\n\r\n      <hr>\r\n\r\n      <div class="cg-reservas-estadias-confirmed-spacing">\r\n        <div class="cg-reservas-estadias-confirmed-space">\r\n          <img class="img-thumbnail" ng-attr-alt="{{$ctrl.model.local.nome}}"\r\n               ng-src="{{$ctrl.getImagemLocal($ctrl.model.local.idErLocal, $ctrl.model.local.imagens)}}"\r\n               fallback-src="{{$ctrl.fallback}}"/>\r\n        </div>\r\n        <div class="cg-reservas-estadias-confirmed-space">\r\n          <div><h4>{{$ctrl.locales.text.startDate}}</h4></div>\r\n          <div><h5>{{$ctrl.getConfirmationDate($ctrl.model.startDate, \'DD MMMM YYYY\')}}</h5></div>\r\n          <div><h5>{{$ctrl.getConfirmationDate($ctrl.model.startDate, \'dddd\')}}</h5></div>\r\n        </div>\r\n\r\n        <div class="cg-reservas-estadias-confirmed-space">\r\n          <div><h4>{{$ctrl.locales.text.endDate}}</h4></div>\r\n          <div><h5>{{$ctrl.getConfirmationDate($ctrl.model.endDate, \'DD MMMM YYYY\')}}</h5></div>\r\n          <div><h5>{{$ctrl.getConfirmationDate($ctrl.model.endDate, \'dddd\')}}</h5></div>\r\n        </div>\r\n\r\n        <div class="cg-reservas-estadias-confirmed-space">\r\n          <div><h4>{{$ctrl.locales.text.guests}}</h4></div>\r\n          <div><h5>{{$ctrl.model.totalAdults}}&nbsp;{{$ctrl.locales.text.adult}}</h5></div>\r\n          <div><h5>{{$ctrl.model.totalChilds}}&nbsp;{{$ctrl.locales.text.child}}</h5></div>\r\n        </div>\r\n      </div>\r\n\r\n      <hr>\r\n\r\n      <div class="table-responsive">\r\n        <table class="table table-condensed table-striped">\r\n          <thead>\r\n          <tr>\r\n            <td><h5><strong>{{$ctrl.locales.form.name}}</strong></h5></td>\r\n            <td class="text-right"><h5><strong>{{$ctrl.locales.text.stayPrice}}</strong></h5></td>\r\n          </tr>\r\n          </thead>\r\n          <tbody>\r\n          <tr ng-repeat="local in $ctrl.model.locais">\r\n            <td>{{local.nome}}</td>\r\n            <td class="text-right">\r\n              <span>{{local.precoUnitLocal * local.nLocaisSelecionados | currency : $ctrl.configurations.currency : $ctrl.configurations.fractionSize}}</span>\r\n              <span ng-if="local.nLocaisSelecionados > 1"> ({{local.nLocaisSelecionados}} * {{local.precoUnitLocal | currency : $ctrl.configurations.currency : $ctrl.configurations.fractionSize}})</span>\r\n            </td>\r\n          </tr>\r\n          </tbody>\r\n          <tfoot>\r\n          <tr>\r\n            <td class="text-right" colspan="2">\r\n              <h4>{{$ctrl.locales.text.total}}:&nbsp;{{$ctrl.model.total | currency : $ctrl.configurations.currency : $ctrl.configurations.fractionSize}}</h4>\r\n            </td>\r\n          </tr>\r\n          </tfoot>\r\n        </table>\r\n      </div>\r\n    </div>\r\n  </pl-form>\r\n</div>\r\n');
$templateCache.put('../source/cgReservasEstadias/templates/cg-reservas-estadias-data-item.html','<div class="cg-reservas-estadias-heading">\n  <span class="summary-title">{{type.nome}}</span>\n</div>\n\n<div class="cg-reservas-estadias-body">\n  <div class="row">\n    <div class="col-xs-12 col-sm-4" ng-click="$ctrl.openGallery(type.idErLocal, type.imagens)">\n      <div class="cg-reservas-estadias-body-thumbnail">\n        <img ng-src="{{$ctrl.getImagemLocal(type.idErLocal, type.imagens)}}" ng-attr-alt="{{type.nome}}"\n             class="img-thumbnail"\n             fallback-src="{{$ctrl.fallback}}"/>\n        <div class="cg-reservas-estadias-body-thumbnail-info" ng-if="type.nmaxPessoasLocal || type.nEquipamentos">\n          <div ng-if="type.nmaxPessoasLocal" ng-attr-title="{{$ctrl.locales.text.limiterPeople}}">\n            <span>{{type.nmaxPessoasLocal}}</span><i class="fa fa-user" aria-hidden="true"></i>\n          </div>\n          <div ng-if="type.nEquipamentos" ng-attr-title="{{$ctrl.locales.text.limiterEquipamentos}}">\n            <span>{{type.nEquipamentos}}</span><i class="fa fa-bed" aria-hidden="true"></i>\n          </div>\n        </div>\n      </div>\n\n      <div class="cg-reservas-estadias-body-minimo-dias" ng-if="type.nDiasMinimoReserva"\n           ng-class="{\'invalid\': type._invalidNDiasMinimoReserva}"\n           ng-bind-html="$ctrl.locales.text.minNumberOfDays | cgreTranslate:{minimum: type.nDiasMinimoReserva}">\n      </div>\n    </div>\n\n    <div class="col-xs-12 col-sm-8">\n      <h5><strong>{{$ctrl.locales.text.description}}</strong></h5>\n      <div pl-promise="type._promise">\n        <div ng-if="!type._promise && type._descricao.length">\n          <div ng-repeat="data in type._descricao">\n            <i class="fa fa-fw fa-check decription-bullet" aria-hidden="true"></i>&nbsp;<span ng-bind-html="data"></span>\n          </div>\n        </div>\n\n        <div ng-if="!type._promise && !type._descricao.length">{{$ctrl.locales.text.emptyInformation}}</div>\n      </div>\n    </div>\n  </div>\n\n  <div class="cg-reservas-estadias-data-type-footer">\n    <div class="cg-reservas-estadias-data-type-footer-column">\n      <div class="cg-reservas-estadias-data-type-footer-column-header">\n        <h5><strong>{{$ctrl.locales.text.people}}</strong></h5>\n      </div>\n\n      <div class="cg-reservas-estadias-data-type-footer-column-body">\n        <div class="cg-reservas-estadias-people-count">\n          <div class="cg-reservas-estadias-data-type-footer-align" pl-tooltip="{text: $ctrl.locales.text.adult, enable: true}">\n            <i class="fa fa-male font-size-h3" aria-hidden="true"></i>\n            <select class="form-control" ng-options="value disable when $ctrl.finished for value in $ctrl.amounts"\n                    ng-model="type.model.NAdultos"\n                    ng-change="$ctrl.changedNumberOfPeople(type)">\n            </select>\n          </div>\n\n          <div class="cg-reservas-estadias-data-type-footer-align" pl-tooltip="{text: $ctrl.locales.text.child, enable: true}">\n            <i class="fa fa-child font-size-h4" aria-hidden="true"></i>\n            <select class="form-control" ng-options="value disable when $ctrl.finished for value in $ctrl.amounts"\n                    ng-model="type.model.NCriancas"\n                    ng-change="$ctrl.changedNumberOfPeople(type)">\n            </select>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class="cg-reservas-estadias-data-type-footer-column">\n      <div class="cg-reservas-estadias-data-type-footer-column-header">\n        <h5><strong>{{$ctrl.locales.text.stayPrice}}</strong></h5>\n      </div>\n\n      <div class="cg-reservas-estadias-data-type-footer-column-body">\n        <span ng-if="!type._invalidMaxNumberOfPeople">{{type.model.precoUnitLocal | currency : $ctrl.configurations.currency : $ctrl.configurations.fractionSize}}</span>\n        <span ng-if="type._invalidMaxNumberOfPeople">-</span>\n      </div>\n    </div>\n\n    <div class="cg-reservas-estadias-data-type-footer-column">\n      <div class="cg-reservas-estadias-data-type-footer-column-header">\n        <h5><strong>{{$ctrl.locales.text.quantity}}:</strong></h5>\n      </div>\n\n      <div class="cg-reservas-estadias-data-type-footer-column-body">\n        <select class="form-control" ng-options="value disable when $ctrl.finished for value in type.amounts"\n                ng-model="type.model.NLocaisSelecionados"\n                ng-change="$ctrl.changedNLocaisSelecionados(type)">\n        </select>\n      </div>\n    </div>\n  </div>\n\n  <div class="cg-reservas-estadias-data-type-validations" ng-if="type._hasError">\n    <div class="cg-reservas-estadias-data-type-validation" ng-if="type.model.NLocaisSelecionados && !type.model.NAdultos">\n      <small>{{$ctrl.locales.text.atLeastOneAdult}}</small>\n    </div>\n\n    <div class="cg-reservas-estadias-data-type-validation" ng-if="type.model.NLocaisSelecionados && type.nmaxPessoasLocal && type._peopleCount > type.nmaxPessoasLocal">\n      <small ng-bind-html="$ctrl.locales.text.maxNumberOfPeople | cgreTranslate:{maximum: type.nmaxPessoasLocal}"></small>\n    </div>\n\n    <div class="cg-reservas-estadias-data-type-validation" ng-if="type._invalidNDiasMinimoReserva">\n      <small ng-bind-html="$ctrl.locales.text.validatorMinNumberOfDays | cgreTranslate:{minimum: type.nmaxPessoasLocal}"></small>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('../source/cgReservasEstadias/templates/cg-reservas-estadias-gallery.html','<div class="modal-body" ng-swipe-left="$ctrl.lightbox.nextImage()" ng-swipe-right="$ctrl.lightbox.prevImage()">\r\n  <div class="lightbox-nav">\r\n    <button class="close" aria-hidden="true" ng-click="$ctrl.lightbox.closeModal()">\xD7</button>\r\n\r\n    <div class="btn-group" ng-if="$ctrl.lightbox.images.length > 1">\r\n      <a class="btn btn-xs btn-default" ng-click="$ctrl.lightbox.prevImage()">\r\n        <i class="fa fa-caret-left" aria-hidden="true"></i>&nbsp;{{$ctrl.locales.btn.previous}}\r\n      </a>\r\n\r\n      <a class="btn btn-xs btn-default" ng-click="$ctrl.lightbox.nextImage()">\r\n        {{$ctrl.locales.btn.next}}&nbsp;<i class="fa fa-caret-right" aria-hidden="true"></i>\r\n      </a>\r\n    </div>\r\n  </div>\r\n\r\n  <div class="lightbox-image-container">\r\n    <div class="lightbox-image-caption">\r\n      <span>{{$ctrl.lightbox.imageCaption}}</span>\r\n    </div>\r\n\r\n    <img ng-if="!$ctrl.lightbox.isVideo($ctrl.lightbox.image)" lightbox-src="{{$ctrl.lightbox.imageUrl}}" fallback-src="{{$ctrl.fallback}}">\r\n  </div>\r\n</div>\r\n');
$templateCache.put('../source/cgReservasEstadias/templates/cg-reservas-estadias-information.html','<div class="cg-reservas-estadias-information">\r\n  <div class="cg-reservas-estadias-heading">\r\n    <span class="summary-title">{{$ctrl.locales.text.information}}</span>\r\n  </div>\r\n\r\n  <div class="cg-reservas-estadias-body">\r\n    <pl-form properties="{disabled: $ctrl.finished, orientation: \'vertical\'}">\r\n      <pl-group>\r\n        <label>{{$ctrl.locales.text.typology}}</label>\r\n        <edit>\r\n          <pl-edit type="select" ng-model="$ctrl.model.typology" ng-change="$ctrl.loadListaLocais()"\r\n                   properties="{select: {valueProp: \'idERTipoLocal\', labelProp: \'nome\', list: $ctrl.typologies}, events: {change: $ctrl.changedSelectedTypology}}">\r\n          </pl-edit>\r\n        </edit>\r\n      </pl-group>\r\n\r\n      <pl-group>\r\n        <label>{{$ctrl.locales.text.startDate}}</label>\r\n        <edit>\r\n          <pl-edit type="date" ng-model="$ctrl.model.startDate" ng-change="$ctrl.changedStartDate()"\r\n                   properties="{dayEnabled: $ctrl.isStartDayEnabled}">\r\n          </pl-edit>\r\n        </edit>\r\n      </pl-group>\r\n\r\n      <pl-group>\r\n        <label>{{$ctrl.locales.text.endDate}}</label>\r\n        <edit>\r\n          <pl-edit type="date" ng-model="$ctrl.model.endDate" ng-change="$ctrl.changedEndDate()"\r\n                   properties="{todayEnabled: $ctrl.isTodayEnabled, dayEnabled: $ctrl.isEndDayEnabled}">\r\n          </pl-edit>\r\n        </edit>\r\n      </pl-group>\r\n    </pl-form>\r\n  </div>\r\n</div>\r\n');
$templateCache.put('../source/cgReservasEstadias/templates/cg-reservas-estadias-summary.html','<div class="cg-reservas-estadias-summary">\r\n  <div class="cg-reservas-estadias-heading">\r\n    <span class="summary-title">{{$ctrl.locales.titles.summary}}</span>\r\n  </div>\r\n\r\n  <div class="cg-reservas-estadias-body">\r\n    <div class="row" ng-if="$ctrl.step === $ctrl.definition.items[3]">\r\n      <div class="col-xs-12 col-sm-6 col-md-6">\r\n        <div class="cg-reservas-estadias-summary-item">\r\n          <h5><strong>{{$ctrl.locales.form.name}}</strong></h5>\r\n          <span>{{$ctrl.model.identificacao.pessoaReserva}}</span>\r\n        </div>\r\n\r\n        <div class="cg-reservas-estadias-summary-item">\r\n          <h5><strong>{{$ctrl.locales.form.country}}</strong></h5>\r\n          <span>{{$ctrl.selectedPais[$ctrl.rowTemplatePaises]}}</span>\r\n        </div>\r\n\r\n        <div class="cg-reservas-estadias-summary-item">\r\n          <h5><strong>{{$ctrl.locales.form.email}}</strong></h5>\r\n          <span>{{$ctrl.model.identificacao.emailReserva}}</span>\r\n        </div>\r\n\r\n        <div class="cg-reservas-estadias-summary-item">\r\n          <h5><strong>{{$ctrl.locales.form.phoneNumber}}</strong></h5>\r\n          <span>{{$ctrl.model.identificacao.contactoReserva}}</span>\r\n        </div>\r\n      </div>\r\n\r\n      <div class="col-xs-12 col-sm-6 col-md-6">\r\n        <div class="cg-reservas-estadias-summary-item">\r\n          <h5><strong>{{$ctrl.locales.text.iban}}</strong></h5>\r\n          <span>{{$ctrl.getCompanyIban()}}</span>\r\n        </div>\r\n\r\n        <div class="cg-reservas-estadias-summary-item">\r\n          <h5><strong>{{$ctrl.locales.text.typology}}</strong></h5>\r\n          <span>{{$ctrl.model.selectedTypology.nome}}</span>\r\n        </div>\r\n\r\n        <div class="cg-reservas-estadias-summary-item">\r\n          <h5><strong>{{$ctrl.locales.text.dates}}</strong></h5>\r\n          <span>{{$ctrl.model.startDate | date : $ctrl.format.date}}</span>&nbsp;{{$ctrl.locales.text.until}}&nbsp;<span>{{$ctrl.model.endDate | date : $ctrl.format.date}}</span>\r\n        </div>\r\n\r\n        <div class="cg-reservas-estadias-summary-item">\r\n          <h5><strong>{{$ctrl.locales.text.people}}</strong></h5>\r\n          <div>\r\n            <span>{{$ctrl.model.totalAdults}}&nbsp;{{$ctrl.locales.text.adult}}</span>\r\n            <span class="item-separator">{{$ctrl.model.totalChilds}}&nbsp;{{$ctrl.locales.text.child}}</span>\r\n          </div>\r\n        </div>\r\n\r\n        <div class="cg-reservas-estadias-summary-item item-currency">\r\n          <h5><strong>{{$ctrl.locales.text.price}}</strong></h5>\r\n          <div>{{$ctrl.model.total | currency : $ctrl.configurations.currency : $ctrl.configurations.fractionSize}}\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n      <div class="col-xs-12">\r\n        <div class="cg-reservas-estadias-summary-item">\r\n          <button type="button" class="btn btn-success pull-right" ng-click="$ctrl.plNavWizard.nextStep()"\r\n                  ng-if="$ctrl.step === $ctrl.definition.items[3] && !$ctrl.finished" pl-promise="$ctrl.summaryPromise">\r\n            <i class="fa fa-calendar-check-o"></i>&nbsp;<span>{{$ctrl.locales.text.finishBooking}}</span>\r\n          </button>\r\n\r\n          <button type="button" class="btn btn-primary" ng-click="$ctrl.doPrint()" pl-promise ng-disabled="!$ctrl.validMeioPagam()"\r\n                  ng-if="$ctrl.step === $ctrl.definition.items[3] && !$ctrl.finished" pl-tooltip="{enable: !$ctrl.validMeioPagam(), text: $ctrl.locales.errors.invalidMeioPagamPrint}">\r\n            <i class="fa fa-print" aria-hidden="true"></i>&nbsp;<span>{{$ctrl.locales.text.print}}</span>\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class="cg-reservas-estadias-summary-item" ng-if="$ctrl.step !== $ctrl.definition.items[3]">\r\n      <h5><strong>{{$ctrl.locales.text.typology}}</strong></h5>\r\n      <span>{{$ctrl.model.selectedTypology.nome}}</span>\r\n    </div>\r\n\r\n    <div class="cg-reservas-estadias-summary-item" ng-if="$ctrl.step !== $ctrl.definition.items[3]">\r\n      <h5><strong>{{$ctrl.locales.text.dates}}</strong></h5>\r\n      <span>{{$ctrl.model.startDate | date : $ctrl.format.date}}</span>&nbsp;{{$ctrl.locales.text.until}}&nbsp;<span>{{$ctrl.model.endDate | date : $ctrl.format.date}}</span>\r\n    </div>\r\n\r\n    <div class="cg-reservas-estadias-summary-item" ng-if="$ctrl.step !== $ctrl.definition.items[3]">\r\n      <h5><strong>{{$ctrl.locales.text.people}}</strong> *</h5>\r\n      <div>\r\n        <span>{{$ctrl.model.totalAdults}}&nbsp;{{$ctrl.locales.text.adult}}</span>\r\n        <span class="item-separator">{{$ctrl.model.totalChilds}}&nbsp;{{$ctrl.locales.text.child}}</span>\r\n      </div>\r\n      <div class="cg-reservas-estadias-summary-item-spacing">\r\n        <small>{{$ctrl.locales.text.ratesAgeFive}}</small>\r\n      </div>\r\n    </div>\r\n\r\n    <div class="cg-reservas-estadias-summary-item item-currency" ng-if="$ctrl.step !== $ctrl.definition.items[3]">\r\n      <h5><strong>{{$ctrl.locales.text.price}}</strong></h5>\r\n      <div>{{$ctrl.model.total | currency : $ctrl.configurations.currency : $ctrl.configurations.fractionSize}}</div>\r\n    </div>\r\n\r\n    <div class="cg-reservas-estadias-summary-item" ng-if="$ctrl.step !== $ctrl.definition.items[3]">\r\n      <button type="button" class="btn btn-primary btn-block" ng-click="$ctrl.plNavWizard.nextStep()"\r\n              ng-if="$ctrl.step === $ctrl.definition.items[1] && !$ctrl.finished" pl-promise="$ctrl.summaryPromise">\r\n        <span ng-attr-title="{{$ctrl.locales.text.next}}">{{$ctrl.locales.text.next}}</span> <i class="fa fa-arrow-right fa-fw"></i>\r\n      </button>\r\n\r\n      <button type="button" class="btn btn-primary btn-block" name="debug" ng-click="$ctrl.plNavWizard.nextStep()"\r\n              ng-if="$ctrl.step === $ctrl.definition.items[2] && !$ctrl.finished" pl-promise="$ctrl.summaryPromise">\r\n        <span ng-attr-title="{{$ctrl.locales.text.nextPayment}}">{{$ctrl.locales.text.nextPayment}}</span> <i class="fa fa-arrow-right fa-fw"></i>\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n');
$templateCache.put('../source/cgReservasEstadias/templates/cg-rgdp-terms.html','<div class="modal-header">\r\n  <button type="button" class="close" ng-click="$ctrl.$dismiss()" data-dismiss="modal" aria-hidden="true">&times;</button>\r\n  <h4 class="modal-title">{{$ctrl.locales.text.rgpdTitle}}</h4>\r\n</div>\r\n\r\n<div class="modal-body text-rgpd">\r\n  <div ng-include="$ctrl.rgpdTermsBody"></div>\r\n</div>\r\n\r\n<div class="modal-footer" pl-navigation selector="button">\r\n  <button type="button" class="btn btn-success" ng-click="$ctrl.$close()">\r\n    <i class="fa fa-check fa-fw"></i>&nbsp;<span>{{$ctrl.locales.btn.close}}</span>\r\n  </button>\r\n</div>\r\n');}]);})();
(function () {
  'use strict';

  angular.module('cgReservasEstadias')
    .provider('cgReservasEstadiasLocale', function () {
      var dictionary = {
        'pt-pt': {
          steps: {
            start: 'Escolha o seu alojamento',
            data: 'Defina os dados da reserva',
            details: 'Insira os seus dados',
            payment: 'Dados para pagamento',
            confirmed: 'Concluído'
          },
          titles: {
            summary: 'Resumo da reserva',
            reservationData: 'Insira os seus dados',
            payment: 'Pagamento',
            confirmed: 'Reserva efetuada com sucesso (pendente de pagamento)',
            confirmedPrint: 'Dados da sua reserva'
          },
          text: {
            all: 'Todos',
            typology: 'Alojamento',
            iban: 'IBAN p/ pagamento',
            startDate: 'Check-In',
            endDate: 'Check-Out',
            next: 'Reservar agora',
            nextPayment: 'Seguir para pagamento',
            book: 'Reservar',
            finishBooking: 'Concluir reserva',
            information: 'Informação marcada',
            dates: 'Datas',
            people: 'Pessoas',
            accommodation: 'Alojamento',
            price: 'Preço',
            description: 'Descrição',
            moreInformation: 'Ver mais informações sobre o local',
            emptyInformation: 'Não há mais informações sobre o local',
            rates: 'Tarifa',
            stayPrice: 'Preço estadia',
            quantity: 'Quantidade',
            adult: 'Adulto(s)',
            child: 'Criança(s)',
            noLocationsAvailable: 'Não existem locais disponíveis entre <strong>{{startDate}}</strong> e <strong>{{endDate}}</strong> para a tipologia (<strong>alojamento</strong>) selecionada.',
            guests: 'Hóspedes',
            sentConfirmationEmail: 'Reserva efetuada com sucesso! Foi enviado um email com a confirmação da reserva',
            total: 'Total',
            print: 'Imprimir',
            finalize: 'Nova reserva',
            until: 'até',
            selectPaymentIban: 'Selecione um método de pagamento',
            rgpd1: 'Aceito os',
            rgpd2: 'termos e condições',
            rgpd3: 'descritos',
            rgpdTitle: 'Autorização do uso de dados pessoais de acordo com o Regulamento Geral da Proteção de Dados',
            ratesAgeFive: 'Crianças até 5 anos não contam para efeitos de pagamento',
            confirmedWarning: 'Reserva efetuada com sucesso, <strong>pendente de pagamento</strong> num prazo máximo de <strong>24h</strong> e contra envio de comprovativo para ' +
              'o email <a href="mailto:parque.campismo@cm-figfoz.pt"><strong>parque.campismo@cm-figfoz.pt</strong></a>. Será enviada uma fatura/recibo para o email disponibilizado.',
            atLeastOneAdult: 'Precisa de selecionar pelo menos um adulto',
            limiterPeople: 'Número máximo de pessoas (adultos e crianças)',
            limiterEquipamentos: 'Camas',
            maxNumberOfPeople: 'Máximo <strong>{{maximum}}</strong> pessoas (adultos e crianças)',
            minNumberOfDays: 'Mínimo <strong>{{minimum}}</strong> noites',
            validatorMinNumberOfDays: 'Para reservar este local, deve selecionar um intervalo de datas (check-in/out) que satisfaça o mínimo de <strong>{{minimum}}</strong> noites'
          },
          btn: {
            previous: 'Anterior',
            next: 'Próximo',
            close: 'Fechar'
          },
          form: {
            name: 'Nome',
            country: 'País',
            nif: 'NIF',
            phoneNumber: 'Telefone',
            email: 'E-mail',
            observations: 'Observações',
            paymentMethod: 'Método de pagamento',
            bankTransfer: 'Transferência bancária',
            confirmation: 'Nº Confirmação',
            rate: 'Tarifa',
            rgpd: 'Autorização RGPD'
          },
          errors: {
            invalidLocationsQty: 'Tem de selecionar pelo menos um local para continuar',
            invalidLocationsNPeople: 'Os locais {{locations}} foram selecionados, mas não definiu a quantidade de pessoas',
            invalidLocationsNAdults: 'Os locais {{locations}} têm de hospedar pelo menos um adulto',
            invalidMaxNumberOfPeople: 'Os locais {{locations}} ultrapassam o limite máximo de pessoas',
            invalidMinNumberOfDays: 'Os locais {{locations}} não satisfazem o mínimo de noites por reserva',
            invalidIdReserva: 'Ocorreu um erro desconhecido ao tentar concluir a sua reserva! Por favor inicie a sua reserva novamente.',
            invalidMeioPagam: 'Tem de selecionar um meio de pagamento para continuar',
            invalidMeioPagamPrint: 'Tem de selecionar um meio de pagamento para puder imprimir',
            rgpdConsent: 'Tem de consentir os termos e condições descritos na autorização do uso de dados pessoais de acordo com o Regulamento Geral da Proteção de Dados'
          }
        }
      };

      var locales = {};
      var currentLocale = 'pt-pt';

      function applyLocale(locale) {
        if (angular.isDefined(dictionary[locale]) && dictionary[locale] !== null) {
          locales = dictionary[locale];
          currentLocale = locale;
          return true;
        }
        return false;
      }

      (function init() {
        applyLocale('pt-pt');
      })();

      return {
        $get: /*@ngInject*/ ['$rootScope', function ($rootScope) {
          (function init() {
            $rootScope.$on('plLocale:appliedLocale', function (event, data) {
              applyLocale(data.lang);
            });
          })();

          return {
            locales: locales,
            locale: currentLocale
          };
        }]
      };
    });
})();

(function () {
  'use strict';

  angular.module('cgReservasEstadias')
    .provider('cgReservasEstadias', ['LightboxProvider', function (LightboxProvider) {
      factory.$inject = ['$http', '$q', 'cgReservasEstadiasCountriesISO3166'];
      var configurations = {
        apiBaseUrl: null,
        apiEndPoint: '/reservasEstadias',
        templates: {
          gallery: '../source/cgReservasEstadias/templates/cg-reservas-estadias-gallery.html',
          information: '../source/cgReservasEstadias/templates/cg-reservas-estadias-information.html',
          summary: '../source/cgReservasEstadias/templates/cg-reservas-estadias-summary.html',
          dataItem: '../source/cgReservasEstadias/templates/cg-reservas-estadias-data-item.html',
          rgpdTerms: '../source/cgReservasEstadias/templates/cg-rgdp-terms.html',
          rgpdTermsBody: ''
        },
        currency: '€',
        fractionSize: 2,
        imageFallbackSource: undefined
      };
      var implementationCheck = ['apiBaseUrl', 'apiEndPoint'];
      var path = configurations.apiBaseUrl + configurations.apiEndPoint;

      function setConfig(object) {
        if (angular.isObject(object)) {
          configurations = _.merge({}, configurations, object);
          path = configurations.apiBaseUrl + configurations.apiEndPoint;
          LightboxProvider.templateUrl = configurations.templates.gallery;
        }
      }

      (function init() {
        setConfig({});
      })();

      var provider = {
        setConfig: setConfig,
        config: function () {
          return configurations;
        },
        $get: /*@ngInject*/ factory
      };
      return provider;

      /////////////

      function factory($http, $q, cgReservasEstadiasCountriesISO3166) {
        return angular.extend(provider, {
          tiposLocaisReservas: tiposLocaisReservas,
          imagemDoLocal: imagemDoLocal,
          confirmarReservaEmail: confirmarReservaEmail,
          descricaoLocal: descricaoLocal,
          pdfDocPagamentoReserva: pdfDocPagamentoReserva,
          imagensLocal: imagensLocal,
          informacaoLocal: informacaoLocal,
          locaisDisponiveis: locaisDisponiveis,
          mapaConfirmacaoReserva: mapaConfirmacaoReserva,
          marcarPreReserva: marcarPreReserva,
          confirmarPreReserva: confirmarPreReserva,
          apagarPreReserva: apagarPreReserva,
          confirmarReserva: confirmarReserva,
          paises: paises,
          empresa: empresa,
          meiosPagamento: meiosPagamento
        });

        function checkConfigurations() {
          for (var i = 0; i < implementationCheck.length; i++) {
            var toCheck = implementationCheck[i];
            if (!configurations[toCheck]) {
              if (!configurations[toCheck]) {
                if (configurations[toCheck] === null) {
                  throw new TypeError('``' + toCheck + '`` property is not defined in provider\'s configuration. This property must be implemented' +
                    'for proper component behaviour');
                }
                else {
                  throw new TypeError('Invalid ``' + toCheck + '`` defined in provider\'s configuration');
                }
              }
            }
          }
        }

        /////////////

        function tiposLocaisReservas(search, page, perpage, orderBy, fields) {
          checkConfigurations();
          var deferred = $q.defer();
          $http.get(path, {params: {pesquisa: search, pagina: page, porpagina: perpage, ordena: orderBy, campospesq: fields}}).then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function imagemDoLocal(idLocal, idDocumento) {
          checkConfigurations();
          return path + '/' + idLocal + '/imagens/' + idDocumento;
        }

        function confirmarReservaEmail(idReserva) {
          checkConfigurations();
          var deferred = $q.defer();
          $http.get(path + '/' + idReserva + '/confirmacaoreservaemail').then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function descricaoLocal(idLocal, idDocumento) {
          checkConfigurations();
          var deferred = $q.defer();
          $http.get(path + '/' + idLocal + '/descricao/' + idDocumento).then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function pdfDocPagamentoReserva(idReserva) {
          checkConfigurations();
          var deferred = $q.defer();
          $http.get(path + '/' + idReserva + '/docpagamentoreservapdf').then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function imagensLocal(idLocal) {
          checkConfigurations();
          var deferred = $q.defer();
          $http.get(path + '/' + idLocal + '/imagens').then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function informacaoLocal(idLocal) {
          checkConfigurations();
          var deferred = $q.defer();
          $http.get(path + '/' + idLocal + '/informacao').then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function locaisDisponiveis(tipoLocal, dataInicio, dataFim) {
          checkConfigurations();
          var deferred = $q.defer();
          $http.get(path + '/' + tipoLocal + '/locaisdisponiveis', {params: {dataIni: dataInicio, dataFim: dataFim}}).then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function mapaConfirmacaoReserva(idReserva) {
          checkConfigurations();
          var deferred = $q.defer();
          $http.get(path + '/' + idReserva + '/mapaconfirmacaoreserva').then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function marcarPreReserva(preReserva, idReservaCab) {
          checkConfigurations();
          var deferred = $q.defer();
          $http.post(path + '/marcarprereserva', preReserva, {params: {idReservaCab: idReservaCab}}).then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function confirmarPreReserva(idPreReserva, preReserva) {
          checkConfigurations();
          var deferred = $q.defer();
          $http.put(path + '/' + idPreReserva, preReserva).then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function apagarPreReserva(idPreReserva) {
          checkConfigurations();
          var deferred = $q.defer();
          $http.delete(path + '/' + idPreReserva).then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function confirmarReserva(idReserva, meioPagamento) {
          checkConfigurations();
          var deferred = $q.defer();
          $http.put(path + '/' + idReserva + '/' + meioPagamento).then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function paises() {
          checkConfigurations();
          var deferred = $q.defer();

          if (cgReservasEstadiasCountriesISO3166) {
            deferred.resolve({data: cgReservasEstadiasCountriesISO3166});
          }
          else {
            $http.get(configurations.apiBaseUrl + '/paises').then(
              function (response) {
                deferred.resolve(response);
              },
              function (error) {
                deferred.reject(error);
              }
            );
          }

          return deferred.promise;
        }

        function empresa() {
          checkConfigurations();
          var deferred = $q.defer();
          $http.get(configurations.apiBaseUrl + '/empresa').then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function meiosPagamento() {
          checkConfigurations();
          var deferred = $q.defer();
          $http.get(configurations.apiBaseUrl + '/documentos/meiospagamento').then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }
      }
    }])
    .constant('cgReservasEstadiasCountriesISO3166', [
      // jshint ignore:start
      {codigo: '020', codigoAlpha2: 'AD', codigoAlpha3: 'AND', designacao: 'Andorra', designacaoPT: 'Andorra', nomePaisPL: 'Principat d\'Andorra', abrevMoeda: 'EUR'},//AD
      {
        codigo: '784',
        codigoAlpha2: 'AE',
        codigoAlpha3: 'ARE',
        designacao: 'United Arab Emirates',
        designacaoPT: 'Emirados Árabes Unidos',
        nomePaisPL: 'دولة الإمارات العربية المتحدة',
        abrevMoeda: 'AED'
      },//AE
      {codigo: '004', codigoAlpha2: 'AF', codigoAlpha3: 'AFG', designacao: 'Afghanistan', designacaoPT: 'Afeganistão', nomePaisPL: 'Afġānistān', abrevMoeda: 'AFN'},//AF
      {
        codigo: '028',
        codigoAlpha2: 'AG',
        codigoAlpha3: 'ATG',
        designacao: 'Antigua and Barbuda',
        designacaoPT: 'Antígua e Barbuda',
        nomePaisPL: 'Antigua and Barbuda',
        abrevMoeda: 'XCD'
      },//AG
      {codigo: '660', codigoAlpha2: 'AI', codigoAlpha3: 'AIA', designacao: 'Anguilla', designacaoPT: 'Anguilha', nomePaisPL: 'Anguilla', abrevMoeda: 'XCD'},//AI
      {codigo: '008', codigoAlpha2: 'AL', codigoAlpha3: 'ALB', designacao: 'Albania', designacaoPT: 'Albânia', nomePaisPL: 'Shqipëria', abrevMoeda: 'ALL'},//AL
      {codigo: '051', codigoAlpha2: 'AM', codigoAlpha3: 'ARM', designacao: 'Armenia', designacaoPT: 'Arménia ', nomePaisPL: 'Հայաստան', abrevMoeda: 'AMD'},//AM
      {
        codigo: '530',
        codigoAlpha2: 'AN',
        codigoAlpha3: 'ANT',
        designacao: 'Netherlands Antilles',
        designacaoPT: 'Antilhas Holandesas',
        nomePaisPL: 'Nederlandse Antillen',
        abrevMoeda: 'ANG'
      },//AN
      {codigo: '024', codigoAlpha2: 'AO', codigoAlpha3: 'AGO', designacao: 'Angola', designacaoPT: 'Angola', nomePaisPL: 'Angola', abrevMoeda: 'AOA'},//AO
      {codigo: '010', codigoAlpha2: 'AQ', codigoAlpha3: 'ATA', designacao: 'Antarctica', designacaoPT: 'Antártida', nomePaisPL: 'Antarctica', abrevMoeda: 'GBP'},//AQ
      {codigo: '032', codigoAlpha2: 'AR', codigoAlpha3: 'ARG', designacao: 'Argentina', designacaoPT: 'Argentina', nomePaisPL: 'Argentina', abrevMoeda: 'ARS'},//AR
      {codigo: '016', codigoAlpha2: 'AS', codigoAlpha3: 'ASM', designacao: 'American Samoa', designacaoPT: 'Samoa Americana', nomePaisPL: 'Amerika Sāmoa', abrevMoeda: 'USD'},//AS
      {codigo: '040', codigoAlpha2: 'AT', codigoAlpha3: 'AUT', designacao: 'Austria', designacaoPT: 'Áustria', nomePaisPL: 'Österreich', abrevMoeda: 'EUR'},//AT
      {codigo: '036', codigoAlpha2: 'AU', codigoAlpha3: 'AUS', designacao: 'Australia', designacaoPT: 'Austrália', nomePaisPL: 'Australia', abrevMoeda: 'AUD'},//AU
      {codigo: '533', codigoAlpha2: 'AW', codigoAlpha3: 'ABW', designacao: 'Aruba', designacaoPT: 'Aruba', nomePaisPL: 'Aruba', abrevMoeda: 'AWG'},//AW
      {codigo: '248', codigoAlpha2: 'AX', codigoAlpha3: 'ALA', designacao: 'Åland Islands', designacaoPT: 'Ilhas Åland', nomePaisPL: 'Åland', abrevMoeda: 'EUR'},//AX
      {codigo: '031', codigoAlpha2: 'AZ', codigoAlpha3: 'AZE', designacao: 'Azerbaijan', designacaoPT: 'Azerbaijão', nomePaisPL: 'Azərbaycan', abrevMoeda: 'AZN'},//AZ
      {
        codigo: '070',
        codigoAlpha2: 'BA',
        codigoAlpha3: 'BIH',
        designacao: 'Bosnia and Herzegovina',
        designacaoPT: 'Bósnia e Herzegovina',
        nomePaisPL: 'Bosna i Hercegovina',
        abrevMoeda: 'BAM'
      },//BA
      {codigo: '052', codigoAlpha2: 'BB', codigoAlpha3: 'BRB', designacao: 'Barbados', designacaoPT: 'Barbados', nomePaisPL: 'Barbados', abrevMoeda: 'BBD'},//BB
      {codigo: '050', codigoAlpha2: 'BD', codigoAlpha3: 'BGD', designacao: 'Bangladesh', designacaoPT: 'Bangladesh', nomePaisPL: 'Bangladesh', abrevMoeda: 'BDT'},//BD
      {codigo: '056', codigoAlpha2: 'BE', codigoAlpha3: 'BEL', designacao: 'Belgium', designacaoPT: 'Bélgica', nomePaisPL: 'België/Belgique/Belgien', abrevMoeda: 'EUR'},//BE
      {codigo: '854', codigoAlpha2: 'BF', codigoAlpha3: 'BFA', designacao: 'Burkina Faso', designacaoPT: 'Burkina Faso', nomePaisPL: 'Burkina Faso', abrevMoeda: 'XOF'},//BF
      {codigo: '100', codigoAlpha2: 'BG', codigoAlpha3: 'BGR', designacao: 'Bulgaria', designacaoPT: 'Bulgária ', nomePaisPL: 'България', abrevMoeda: 'BGN'},//BG
      {codigo: '048', codigoAlpha2: 'BH', codigoAlpha3: 'BHR', designacao: 'Bahrain', designacaoPT: 'Bahrein', nomePaisPL: ' ‏البحرين', abrevMoeda: 'BHD'},//BH
      {codigo: '108', codigoAlpha2: 'BI', codigoAlpha3: 'BDI', designacao: 'Burundi', designacaoPT: 'Burúndi', nomePaisPL: 'Uburundi/Burundi', abrevMoeda: 'BIF'},//BI
      {codigo: '204', codigoAlpha2: 'BJ', codigoAlpha3: 'BEN', designacao: 'Benin', designacaoPT: 'Benim', nomePaisPL: 'Bénin', abrevMoeda: 'XOF'},//BJ
      {
        codigo: '652',
        codigoAlpha2: 'BL',
        codigoAlpha3: 'BLM',
        designacao: 'Saint Barthélemy',
        designacaoPT: 'Coletividade de São Bartolomeu',
        nomePaisPL: 'Saint-Barthélemy',
        abrevMoeda: 'EUR'
      },//BL
      {codigo: '060', codigoAlpha2: 'BM', codigoAlpha3: 'BMU', designacao: 'Bermuda', designacaoPT: 'Bermudas', nomePaisPL: 'Bermuda', abrevMoeda: 'BMD'},//BM
      {codigo: '096', codigoAlpha2: 'BN', codigoAlpha3: 'BRN', designacao: 'Brunei Darussalam', designacaoPT: 'Brunei', nomePaisPL: 'Brunei Darussalam', abrevMoeda: 'BND'},//BN
      {codigo: '068', codigoAlpha2: 'BO', codigoAlpha3: 'BOL', designacao: 'Bolivia, Plurinational State of', designacaoPT: 'Bolívia', nomePaisPL: 'Bolivia', abrevMoeda: 'BOB'},//BO
      {codigo: '076', codigoAlpha2: 'BR', codigoAlpha3: 'BRA', designacao: 'Brazil', designacaoPT: 'Brasil', nomePaisPL: 'Brasil', abrevMoeda: 'BRL'},//BR
      {codigo: '044', codigoAlpha2: 'BS', codigoAlpha3: 'BHS', designacao: 'Bahamas', designacaoPT: 'Bahamas', nomePaisPL: 'Bahamas', abrevMoeda: 'BSD'},//BS
      {codigo: '064', codigoAlpha2: 'BT', codigoAlpha3: 'BTN', designacao: 'Bhutan', designacaoPT: 'Butão', nomePaisPL: 'འབྲུག་ཡུལ་', abrevMoeda: 'BTN'},//BT
      {codigo: '074', codigoAlpha2: 'BV', codigoAlpha3: 'BVT', designacao: 'Bouvet Island', designacaoPT: 'Ilha Bouvet', nomePaisPL: 'Bouvetøya', abrevMoeda: 'NOK'},//BV
      {codigo: '072', codigoAlpha2: 'BW', codigoAlpha3: 'BWA', designacao: 'Botswana', designacaoPT: 'Botswana', nomePaisPL: 'Botswana', abrevMoeda: 'BWP'},//BW
      {codigo: '112', codigoAlpha2: 'BY', codigoAlpha3: 'BLR', designacao: 'Belarus', designacaoPT: 'Bielorrússia', nomePaisPL: 'Белару́сь', abrevMoeda: 'BYR'},//BY
      {codigo: '084', codigoAlpha2: 'BZ', codigoAlpha3: 'BLZ', designacao: 'Belize', designacaoPT: 'Belize', nomePaisPL: 'Belize', abrevMoeda: 'BZD'},//BZ
      {codigo: '124', codigoAlpha2: 'CA', codigoAlpha3: 'CAN', designacao: 'Canada', designacaoPT: 'Canadá', nomePaisPL: 'Canada', abrevMoeda: 'CAD'},//CA
      {codigo: '166', codigoAlpha2: 'CC', codigoAlpha3: 'CCK', designacao: 'Cocos (Keeling) Islands', designacaoPT: 'Ilhas Cocos', nomePaisPL: 'Keeling Islands', abrevMoeda: 'AUD'},//CC
      {
        codigo: '180',
        codigoAlpha2: 'CD',
        codigoAlpha3: 'COD',
        designacao: 'Congo, the Democratic Republic of the',
        designacaoPT: 'República Democrática do Congo',
        nomePaisPL: 'Jamhuri ya Kidemokrasia ya Cong',
        abrevMoeda: 'CDF'
      },//CD
      {
        codigo: '140',
        codigoAlpha2: 'CF',
        codigoAlpha3: 'CAF',
        designacao: 'Central African Republic',
        designacaoPT: 'República Centro-Africana',
        nomePaisPL: 'République Centrafricaine',
        abrevMoeda: 'XAF'
      },//CF
      {codigo: '178', codigoAlpha2: 'CG', codigoAlpha3: 'COG', designacao: 'Congo', designacaoPT: 'Congo', nomePaisPL: 'Congo', abrevMoeda: 'XAF'},//CG
      {codigo: '756', codigoAlpha2: 'CH', codigoAlpha3: 'CHE', designacao: 'Switzerland', designacaoPT: 'Suíça', nomePaisPL: 'Schweiz/Suisse/Svizzera/Svizra', abrevMoeda: 'CHF'},//CH
      {codigo: '384', codigoAlpha2: 'CI', codigoAlpha3: 'CIV', designacao: 'Côte d\'Ivoire', designacaoPT: 'Costa do Marfim', nomePaisPL: 'Côte d\'Ivoire', abrevMoeda: 'XOF'},//CI
      {codigo: '184', codigoAlpha2: 'CK', codigoAlpha3: 'COK', designacao: 'Cook Islands', designacaoPT: 'Ilhas Cook', nomePaisPL: 'Cook Islands', abrevMoeda: 'NZD'},//CK
      {codigo: '152', codigoAlpha2: 'CL', codigoAlpha3: 'CHL', designacao: 'Chile', designacaoPT: 'Chile', nomePaisPL: 'Chile', abrevMoeda: 'CLP'},//CL
      {codigo: '120', codigoAlpha2: 'CM', codigoAlpha3: 'CMR', designacao: 'Cameroon', designacaoPT: 'Camarões', nomePaisPL: 'Cameroun', abrevMoeda: 'XAF'},//CM
      {codigo: '156', codigoAlpha2: 'CN', codigoAlpha3: 'CHN', designacao: 'China', designacaoPT: 'China', nomePaisPL: '中華人民共和國', abrevMoeda: 'CNY'},//CN
      {codigo: '170', codigoAlpha2: 'CO', codigoAlpha3: 'COL', designacao: 'Colombia', designacaoPT: 'Colômbia', nomePaisPL: 'Colombia', abrevMoeda: 'COP'},//CO
      {codigo: '188', codigoAlpha2: 'CR', codigoAlpha3: 'CRI', designacao: 'Costa Rica', designacaoPT: 'Costa Rica', nomePaisPL: 'Costa Rica', abrevMoeda: 'CRC'},//CR
      {codigo: '192', codigoAlpha2: 'CU', codigoAlpha3: 'CUB', designacao: 'Cuba', designacaoPT: 'Cuba', nomePaisPL: 'Cuba', abrevMoeda: 'CUP'},//CU
      {codigo: '132', codigoAlpha2: 'CV', codigoAlpha3: 'CPV', designacao: 'Cape Verde', designacaoPT: 'Cabo Verde', nomePaisPL: 'Cabo Verde', abrevMoeda: 'CVE'},//CV
      {codigo: '162', codigoAlpha2: 'CX', codigoAlpha3: 'CXR', designacao: 'Christmas Island', designacaoPT: 'Ilha do Natal', nomePaisPL: 'Christmas Island', abrevMoeda: 'AUD'},//CX
      {codigo: '196', codigoAlpha2: 'CY', codigoAlpha3: 'CYP', designacao: 'Cyprus', designacaoPT: 'Chipre', nomePaisPL: 'Κύπρος/Kıbrıs', abrevMoeda: 'EUR'},//CY
      {codigo: '203', codigoAlpha2: 'CZ', codigoAlpha3: 'CZE', designacao: 'Czech Republic', designacaoPT: 'República Checa', nomePaisPL: 'Česká republika', abrevMoeda: 'CZK'},//CZ
      {codigo: '276', codigoAlpha2: 'DE', codigoAlpha3: 'DEU', designacao: 'Germany', designacaoPT: 'Alemanha', nomePaisPL: 'Deutschland', abrevMoeda: 'EUR'},//DE
      {codigo: '262', codigoAlpha2: 'DJ', codigoAlpha3: 'DJI', designacao: 'Djibouti', designacaoPT: 'Djibuti', nomePaisPL: 'جيبوتي', abrevMoeda: 'DJF'},//DJ
      {codigo: '208', codigoAlpha2: 'DK', codigoAlpha3: 'DNK', designacao: 'Denmark', designacaoPT: 'Dinamarca', nomePaisPL: 'Danmark', abrevMoeda: 'DKK'},//DK
      {codigo: '212', codigoAlpha2: 'DM', codigoAlpha3: 'DMA', designacao: 'Dominica', designacaoPT: 'Domínica', nomePaisPL: 'Dominica', abrevMoeda: 'XCD'},//DM
      {
        codigo: '214',
        codigoAlpha2: 'DO',
        codigoAlpha3: 'DOM',
        designacao: 'Dominican Republic',
        designacaoPT: 'República Dominicana',
        nomePaisPL: 'República Dominicana',
        abrevMoeda: 'DOP'
      },//DO
      {codigo: '012', codigoAlpha2: 'DZ', codigoAlpha3: 'DZA', designacao: 'Algeria', designacaoPT: 'Argélia', nomePaisPL: 'الجزائر', abrevMoeda: 'DZD'},//DZ
      {codigo: '218', codigoAlpha2: 'EC', codigoAlpha3: 'ECU', designacao: 'Ecuador', designacaoPT: 'Equador', nomePaisPL: 'Ecuador', abrevMoeda: 'USD'},//EC
      {codigo: '233', codigoAlpha2: 'EE', codigoAlpha3: 'EST', designacao: 'Estonia', designacaoPT: 'Estónia', nomePaisPL: 'Eesti', abrevMoeda: 'EUR'},//EE
      {codigo: '818', codigoAlpha2: 'EG', codigoAlpha3: 'EGY', designacao: 'Egypt', designacaoPT: 'Egito', nomePaisPL: 'مصر', abrevMoeda: 'EGP'},//EG
      {codigo: '732', codigoAlpha2: 'EH', codigoAlpha3: 'ESH', designacao: 'Western Sahara', designacaoPT: 'Saara Ocidental', nomePaisPL: 'الصحراء الغربية', abrevMoeda: 'MAD'},//EH
      {codigo: '232', codigoAlpha2: 'ER', codigoAlpha3: 'ERI', designacao: 'Eritrea', designacaoPT: 'Eritreia', nomePaisPL: 'ኤርትራ', abrevMoeda: 'ERN'},//ER
      {codigo: '724', codigoAlpha2: 'ES', codigoAlpha3: 'ESP', designacao: 'Spain', designacaoPT: 'Espanha', nomePaisPL: 'España', abrevMoeda: 'EUR'},//ES
      {codigo: '231', codigoAlpha2: 'ET', codigoAlpha3: 'ETH', designacao: 'Ethiopia', designacaoPT: 'Etiópia', nomePaisPL: 'ኢትዮጵያ', abrevMoeda: 'ETB'},//ET
      {codigo: '246', codigoAlpha2: 'FI', codigoAlpha3: 'FIN', designacao: 'Finland', designacaoPT: 'Finlândia', nomePaisPL: 'Suomi', abrevMoeda: 'EUR'},//FI
      {codigo: '242', codigoAlpha2: 'FJ', codigoAlpha3: 'FJI', designacao: 'Fiji', designacaoPT: 'Fiji', nomePaisPL: 'Viti', abrevMoeda: 'FJD'},//FJ
      {
        codigo: '238',
        codigoAlpha2: 'FK',
        codigoAlpha3: 'FLK',
        designacao: 'Falkland Islands (Malvinas)',
        designacaoPT: 'Ilhas Malvinas',
        nomePaisPL: 'Falkland Islands',
        abrevMoeda: 'FKP'
      },//FK
      {
        codigo: '583',
        codigoAlpha2: 'FM',
        codigoAlpha3: 'FSM',
        designacao: 'Micronesia, Federated States of',
        designacaoPT: 'Estados Federados da Micronésia',
        nomePaisPL: 'Micronesia, Federated States of',
        abrevMoeda: 'USD'
      },//FM
      {codigo: '234', codigoAlpha2: 'FO', codigoAlpha3: 'FRO', designacao: 'Faroe Islands', designacaoPT: 'Ilhas Faroé', nomePaisPL: 'Føroyar', abrevMoeda: 'DKK'},//FO
      {codigo: '250', codigoAlpha2: 'FR', codigoAlpha3: 'FRA', designacao: 'France', designacaoPT: 'França', nomePaisPL: 'France', abrevMoeda: 'EUR'},//FR
      {codigo: '266', codigoAlpha2: 'GA', codigoAlpha3: 'GAB', designacao: 'Gabon', designacaoPT: 'Gabão', nomePaisPL: 'Gabon', abrevMoeda: 'XAF'},//GA
      {codigo: '826', codigoAlpha2: 'GB', codigoAlpha3: 'GBR', designacao: 'United Kingdom', designacaoPT: 'Reino Unido', nomePaisPL: 'United Kingdom', abrevMoeda: 'GBP'},//GB
      {codigo: '308', codigoAlpha2: 'GD', codigoAlpha3: 'GRD', designacao: 'Grenada', designacaoPT: 'Granada ', nomePaisPL: 'Grenada', abrevMoeda: 'XCD'},//GD
      {codigo: '268', codigoAlpha2: 'GE', codigoAlpha3: 'GEO', designacao: 'Georgia', designacaoPT: 'Geórgia ', nomePaisPL: 'საქართველო', abrevMoeda: 'GEL'},//GE
      {codigo: '254', codigoAlpha2: 'GF', codigoAlpha3: 'GUF', designacao: 'French Guiana', designacaoPT: 'Guiana Francesa', nomePaisPL: 'Guyane Française', abrevMoeda: 'EUR'},//GF
      {codigo: '831', codigoAlpha2: 'GG', codigoAlpha3: 'GGY', designacao: 'Guernsey', designacaoPT: 'Guérnsei', nomePaisPL: 'Guernsey', abrevMoeda: 'GGP'},//GG
      {codigo: '288', codigoAlpha2: 'GH', codigoAlpha3: 'GHA', designacao: 'Ghana', designacaoPT: 'Gana', nomePaisPL: 'Ghana', abrevMoeda: 'GHS'},//GH
      {codigo: '292', codigoAlpha2: 'GI', codigoAlpha3: 'GIB', designacao: 'Gibraltar', designacaoPT: 'Gibraltar', nomePaisPL: 'Gibraltar', abrevMoeda: 'GIP'},//GI
      {codigo: '304', codigoAlpha2: 'GL', codigoAlpha3: 'GRL', designacao: 'Greenland', designacaoPT: 'Gronelândia', nomePaisPL: 'Kalaallit Nunaat', abrevMoeda: 'DKK'},//GL
      {codigo: '270', codigoAlpha2: 'GM', codigoAlpha3: 'GMB', designacao: 'Gambia', designacaoPT: 'Gâmbia', nomePaisPL: 'Gambia', abrevMoeda: 'GMD'},//GM
      {codigo: '324', codigoAlpha2: 'GN', codigoAlpha3: 'GIN', designacao: 'Guinea', designacaoPT: 'Guiné', nomePaisPL: 'Guinée', abrevMoeda: 'GNF'},//GN
      {codigo: '312', codigoAlpha2: 'GP', codigoAlpha3: 'GLP', designacao: 'Guadeloupe', designacaoPT: 'Guadalupe', nomePaisPL: 'Guadeloupe', abrevMoeda: 'EUR'},//GP
      {codigo: '226', codigoAlpha2: 'GQ', codigoAlpha3: 'GNQ', designacao: 'Equatorial Guinea', designacaoPT: 'Guiné Equatorial', nomePaisPL: 'Guinea Ecuatorial', abrevMoeda: 'XAF'},//GQ
      {codigo: '300', codigoAlpha2: 'GR', codigoAlpha3: 'GRC', designacao: 'Greece', designacaoPT: 'Grécia', nomePaisPL: 'Ελλάδα', abrevMoeda: 'EUR'},//GR
      {
        codigo: '239',
        codigoAlpha2: 'GS',
        codigoAlpha3: 'SGS',
        designacao: 'South Georgia and the South Sandwich Islands',
        designacaoPT: 'Ilhas Geórgia do Sul e Sandwich do Sul',
        nomePaisPL: 'South Georgia and the South Sandwich Islands',
        abrevMoeda: 'GBP'
      },//GS
      {codigo: '320', codigoAlpha2: 'GT', codigoAlpha3: 'GTM', designacao: 'Guatemala', designacaoPT: 'Guatemala', nomePaisPL: 'Guatemala', abrevMoeda: 'GTQ'},//GT
      {codigo: '316', codigoAlpha2: 'GU', codigoAlpha3: 'GUM', designacao: 'Guam', designacaoPT: 'Guame', nomePaisPL: 'Guåhån', abrevMoeda: 'USD'},//GU
      {codigo: '624', codigoAlpha2: 'GW', codigoAlpha3: 'GNB', designacao: 'Guinea-Bissau', designacaoPT: 'Guiné-Bissau', nomePaisPL: 'Guinea-Bissau', abrevMoeda: 'XOF'},//GW
      {codigo: '328', codigoAlpha2: 'GY', codigoAlpha3: 'GUY', designacao: 'Guyana', designacaoPT: 'Guiana', nomePaisPL: 'Guyana', abrevMoeda: 'GYD'},//GY
      {codigo: '344', codigoAlpha2: 'HK', codigoAlpha3: 'HKG', designacao: 'Hong Kong', designacaoPT: 'Hong Kong', nomePaisPL: 'Hong Kong', abrevMoeda: 'HKD'},//HK
      {
        codigo: '334',
        codigoAlpha2: 'HM',
        codigoAlpha3: 'HMD',
        designacao: 'Heard Island and McDonald Islands',
        designacaoPT: 'Ilha Heard e as Ilhas McDonald',
        nomePaisPL: 'Heard Island and McDonald Islands',
        abrevMoeda: 'AUD'
      },//HM
      {codigo: '340', codigoAlpha2: 'HN', codigoAlpha3: 'HND', designacao: 'Honduras', designacaoPT: 'Honduras', nomePaisPL: 'Honduras', abrevMoeda: 'HNL'},//HN
      {codigo: '191', codigoAlpha2: 'HR', codigoAlpha3: 'HRV', designacao: 'Croatia', designacaoPT: 'Croácia', nomePaisPL: 'Hrvatska', abrevMoeda: 'HRK'},//HR
      {codigo: '332', codigoAlpha2: 'HT', codigoAlpha3: 'HTI', designacao: 'Haiti', designacaoPT: 'Haiti', nomePaisPL: 'Haïti', abrevMoeda: 'HTG'},//HT
      {codigo: '348', codigoAlpha2: 'HU', codigoAlpha3: 'HUN', designacao: 'Hungary', designacaoPT: 'Hungria', nomePaisPL: 'Magyarország', abrevMoeda: 'HUF'},//HU
      {codigo: '360', codigoAlpha2: 'ID', codigoAlpha3: 'IDN', designacao: 'Indonesia', designacaoPT: 'Indonésia', nomePaisPL: 'Indonesia', abrevMoeda: 'IDR'},//ID
      {codigo: '372', codigoAlpha2: 'IE', codigoAlpha3: 'IRL', designacao: 'Ireland', designacaoPT: 'Irlanda', nomePaisPL: 'Ireland', abrevMoeda: 'EUR'},//IE
      {codigo: '376', codigoAlpha2: 'IL', codigoAlpha3: 'ISR', designacao: 'Israel', designacaoPT: 'Israel', nomePaisPL: 'מְדִינַת יִשְׂרָאֵל', abrevMoeda: 'ILS'},//IL
      {codigo: '833', codigoAlpha2: 'IM', codigoAlpha3: 'IMN', designacao: 'Isle of Man', designacaoPT: 'Ilha de Man', nomePaisPL: 'Isle of Man', abrevMoeda: 'IMP'},//IM
      {codigo: '356', codigoAlpha2: 'IN', codigoAlpha3: 'IND', designacao: 'India', designacaoPT: 'Índia', nomePaisPL: 'Bharat Ganrajya', abrevMoeda: 'INR'},//IN
      {
        codigo: '086',
        codigoAlpha2: 'IO',
        codigoAlpha3: 'IOT',
        designacao: 'British Indian Ocean Territory',
        designacaoPT: 'Território Britânico do Oceano Índico',
        nomePaisPL: 'British Indian Ocean Territory',
        abrevMoeda: 'GBP'
      },//IO
      {codigo: '368', codigoAlpha2: 'IQ', codigoAlpha3: 'IRQ', designacao: 'Iraq', designacaoPT: 'Iraque', nomePaisPL: 'العراق', abrevMoeda: 'IQD'},//IQ
      {codigo: '364', codigoAlpha2: 'IR', codigoAlpha3: 'IRN', designacao: 'Iran, Islamic Republic of', designacaoPT: 'Irão', nomePaisPL: 'جمهوری اسلامی ایران', abrevMoeda: 'IRR'},//IR
      {codigo: '352', codigoAlpha2: 'IS', codigoAlpha3: 'ISL', designacao: 'Iceland', designacaoPT: 'Islândia', nomePaisPL: 'Ísland', abrevMoeda: 'ISK'},//IS
      {codigo: '380', codigoAlpha2: 'IT', codigoAlpha3: 'ITA', designacao: 'Italy', designacaoPT: 'Itália', nomePaisPL: 'Italia', abrevMoeda: 'EUR'},//IT
      {codigo: '832', codigoAlpha2: 'JE', codigoAlpha3: 'JEY', designacao: 'Jersey', designacaoPT: 'Jersey', nomePaisPL: 'Jersey', abrevMoeda: 'JEP'},//JE
      {codigo: '388', codigoAlpha2: 'JM', codigoAlpha3: 'JAM', designacao: 'Jamaica', designacaoPT: 'Jamaica', nomePaisPL: 'Jamaica', abrevMoeda: 'JMD'},//JM
      {codigo: '400', codigoAlpha2: 'JO', codigoAlpha3: 'JOR', designacao: 'Jordan', designacaoPT: 'Jordânia', nomePaisPL: 'اَلأُرْدُنّ', abrevMoeda: 'JOD'},//JO
      {codigo: '392', codigoAlpha2: 'JP', codigoAlpha3: 'JPN', designacao: 'Japan', designacaoPT: 'Japão', nomePaisPL: '日本', abrevMoeda: 'JPY'},//JP
      {codigo: '404', codigoAlpha2: 'KE', codigoAlpha3: 'KEN', designacao: 'Kenya', designacaoPT: 'Quênia', nomePaisPL: 'Kenya', abrevMoeda: 'KES'},//KE
      {codigo: '417', codigoAlpha2: 'KG', codigoAlpha3: 'KGZ', designacao: 'Kyrgyzstan', designacaoPT: 'Quirguistão', nomePaisPL: 'Кыргызстан', abrevMoeda: 'KGS'},//KG
      {codigo: '116', codigoAlpha2: 'KH', codigoAlpha3: 'KHM', designacao: 'Cambodia', designacaoPT: 'Camboja', nomePaisPL: 'ព្រះរាជាណាចក្រកម្ពុជា', abrevMoeda: 'KHR'},//KH
      {codigo: '296', codigoAlpha2: 'KI', codigoAlpha3: 'KIR', designacao: 'Kiribati', designacaoPT: 'Quiribáti', nomePaisPL: 'Kiribati', abrevMoeda: 'AUD'},//KI
      {codigo: '174', codigoAlpha2: 'KM', codigoAlpha3: 'COM', designacao: 'Comoros', designacaoPT: 'União das Comores', nomePaisPL: 'Udzima wa Komori', abrevMoeda: 'KMF'},//KM
      {
        codigo: '659',
        codigoAlpha2: 'KN',
        codigoAlpha3: 'KNA',
        designacao: 'Saint Kitts and Nevis',
        designacaoPT: 'São Cristóvão e Nevis',
        nomePaisPL: 'Saint Kitts and Nevis',
        abrevMoeda: 'XCD'
      },//KN
      {
        codigo: '408',
        codigoAlpha2: 'KP',
        codigoAlpha3: 'PRK',
        designacao: 'Korea, Democratic People\'s Republic of',
        designacaoPT: 'Coreia do Norte',
        nomePaisPL: 'North Korea',
        abrevMoeda: 'KPW'
      },//KP
      {codigo: '410', codigoAlpha2: 'KR', codigoAlpha3: 'KOR', designacao: 'Korea, Republic of', designacaoPT: 'Coreia do Sul', nomePaisPL: 'South Korea', abrevMoeda: 'KRW'},//KR
      {codigo: '414', codigoAlpha2: 'KW', codigoAlpha3: 'KWT', designacao: 'Kuwait', designacaoPT: 'Koweit', nomePaisPL: 'دولة الكويت', abrevMoeda: 'KWD'},//KW
      {codigo: '136', codigoAlpha2: 'KY', codigoAlpha3: 'CYM', designacao: 'Cayman Islands', designacaoPT: 'Ilhas Caimão', nomePaisPL: 'Cayman Islands', abrevMoeda: 'KYD'},//KY
      {codigo: '398', codigoAlpha2: 'KZ', codigoAlpha3: 'KAZ', designacao: 'Kazakhstan', designacaoPT: 'Cazaquistão', nomePaisPL: 'Қазақстан Qazaqstan', abrevMoeda: 'KZT'},//KZ
      {
        codigo: '418',
        codigoAlpha2: 'LA',
        codigoAlpha3: 'LAO',
        designacao: 'Lao People\'s Democratic Republic',
        designacaoPT: 'Laos',
        nomePaisPL: 'ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ',
        abrevMoeda: 'LAK'
      },//LA
      {codigo: '422', codigoAlpha2: 'LB', codigoAlpha3: 'LBN', designacao: 'Lebanon', designacaoPT: 'Líbano', nomePaisPL: 'لبنان', abrevMoeda: 'LBP'},//LB
      {codigo: '662', codigoAlpha2: 'LC', codigoAlpha3: 'LCA', designacao: 'Saint Lucia', designacaoPT: 'Santa Lúcia', nomePaisPL: 'Saint Lucia', abrevMoeda: 'XCD'},//LC
      {codigo: '438', codigoAlpha2: 'LI', codigoAlpha3: 'LIE', designacao: 'Liechtenstein', designacaoPT: 'Liechtenstein', nomePaisPL: 'Fürstentum Liechtenstein', abrevMoeda: 'CHF'},//LI
      {codigo: '144', codigoAlpha2: 'LK', codigoAlpha3: 'LKA', designacao: 'Sri Lanka', designacaoPT: 'Sri Lanka', nomePaisPL: 'ශ්‍රී ලංකාව', abrevMoeda: 'LKR'},//LK
      {codigo: '430', codigoAlpha2: 'LR', codigoAlpha3: 'LBR', designacao: 'Liberia', designacaoPT: 'Libéria', nomePaisPL: 'Liberia', abrevMoeda: 'LRD'},//LR
      {codigo: '426', codigoAlpha2: 'LS', codigoAlpha3: 'LSO', designacao: 'Lesotho', designacaoPT: 'Lesoto', nomePaisPL: 'Lesotho', abrevMoeda: 'LSL'},//LS
      {codigo: '440', codigoAlpha2: 'LT', codigoAlpha3: 'LTU', designacao: 'Lithuania', designacaoPT: 'Lituânia', nomePaisPL: 'Lietuva', abrevMoeda: 'LTL'},//LT
      {codigo: '442', codigoAlpha2: 'LU', codigoAlpha3: 'LUX', designacao: 'Luxembourg', designacaoPT: 'Luxemburgo', nomePaisPL: 'Lëtzebuerg', abrevMoeda: 'EUR'},//LU
      {codigo: '428', codigoAlpha2: 'LV', codigoAlpha3: 'LVA', designacao: 'Latvia', designacaoPT: 'Letónia', nomePaisPL: 'Latvija', abrevMoeda: 'LVL'},//LV
      {codigo: '434', codigoAlpha2: 'LY', codigoAlpha3: 'LBY', designacao: 'Libyan Arab Jamahiriya', designacaoPT: 'Líbia', nomePaisPL: 'ليبيا', abrevMoeda: 'LYD'},//LY
      {codigo: '504', codigoAlpha2: 'MA', codigoAlpha3: 'MAR', designacao: 'Morocco', designacaoPT: 'Marrocos', nomePaisPL: 'المغرب', abrevMoeda: 'MAD'},//MA
      {codigo: '492', codigoAlpha2: 'MC', codigoAlpha3: 'MCO', designacao: 'Monaco', designacaoPT: 'Mónaco', nomePaisPL: 'Monaco', abrevMoeda: 'EUR'},//MC
      {codigo: '498', codigoAlpha2: 'MD', codigoAlpha3: 'MDA', designacao: 'Moldova, Republic of', designacaoPT: 'Moldávia', nomePaisPL: 'Moldova', abrevMoeda: 'MDL'},//MD
      {codigo: '499', codigoAlpha2: 'ME', codigoAlpha3: 'MNE', designacao: 'Montenegro', designacaoPT: 'Montenegro', nomePaisPL: 'Crna Gora', abrevMoeda: 'EUR'},//ME
      {
        codigo: '663',
        codigoAlpha2: 'MF',
        codigoAlpha3: 'MAF',
        designacao: 'Saint Martin (French part)',
        designacaoPT: 'São Martinho (Parte Francesa)',
        nomePaisPL: 'Saint Martin',
        abrevMoeda: 'EUR'
      },//MF
      {codigo: '450', codigoAlpha2: 'MG', codigoAlpha3: 'MDG', designacao: 'Madagascar', designacaoPT: 'Madagáscar', nomePaisPL: 'Madagasikara', abrevMoeda: 'MGA'},//MG
      {codigo: '584', codigoAlpha2: 'MH', codigoAlpha3: 'MHL', designacao: 'Marshall Islands', designacaoPT: 'Ilhas Marshall', nomePaisPL: 'Marshall Islands', abrevMoeda: 'USD'},//MH
      {
        codigo: '807',
        codigoAlpha2: 'MK',
        codigoAlpha3: 'MKD',
        designacao: 'Macedonia, the former Yugoslav Republic of',
        designacaoPT: 'República da Macedónia',
        nomePaisPL: 'Македонија',
        abrevMoeda: 'MKD'
      },//MK
      {codigo: '466', codigoAlpha2: 'ML', codigoAlpha3: 'MLI', designacao: 'Mali', designacaoPT: 'Mali', nomePaisPL: 'Mali', abrevMoeda: 'XOF'},//ML
      {codigo: '104', codigoAlpha2: 'MM', codigoAlpha3: 'MMR', designacao: 'Myanmar', designacaoPT: 'Birmânia', nomePaisPL: 'Myanmar', abrevMoeda: 'MMK'},//MM
      {codigo: '496', codigoAlpha2: 'MN', codigoAlpha3: 'MNG', designacao: 'Mongolia', designacaoPT: 'Mongólia', nomePaisPL: 'Монгол улс', abrevMoeda: 'MNT'},//MN
      {codigo: '446', codigoAlpha2: 'MO', codigoAlpha3: 'MAC', designacao: 'Macao', designacaoPT: 'Macau', nomePaisPL: '澳門', abrevMoeda: 'MOP'},//MO
      {
        codigo: '580',
        codigoAlpha2: 'MP',
        codigoAlpha3: 'MNP',
        designacao: 'Northern Mariana Islands',
        designacaoPT: 'Ilhas Marianas do Norte',
        nomePaisPL: 'Sankattan Siha Na Islas Mariånas',
        abrevMoeda: 'USD'
      },//MP
      {codigo: '474', codigoAlpha2: 'MQ', codigoAlpha3: 'MTQ', designacao: 'Martinique', designacaoPT: 'Martinica', nomePaisPL: 'Martinique', abrevMoeda: 'EUR'},//MQ
      {codigo: '478', codigoAlpha2: 'MR', codigoAlpha3: 'MRT', designacao: 'Mauritania', designacaoPT: 'Mauritânia', nomePaisPL: 'موريتانيا', abrevMoeda: 'MRO'},//MR
      {codigo: '500', codigoAlpha2: 'MS', codigoAlpha3: 'MSR', designacao: 'Montserrat', designacaoPT: 'Montserrat', nomePaisPL: 'Montserrat', abrevMoeda: 'XCD'},//MS
      {codigo: '470', codigoAlpha2: 'MT', codigoAlpha3: 'MLT', designacao: 'Malta', designacaoPT: 'Malta', nomePaisPL: 'Malta', abrevMoeda: 'EUR'},//MT
      {codigo: '480', codigoAlpha2: 'MU', codigoAlpha3: 'MUS', designacao: 'Mauritius', designacaoPT: 'Maurícia', nomePaisPL: 'Maurice', abrevMoeda: 'MUR'},//MU
      {codigo: '462', codigoAlpha2: 'MV', codigoAlpha3: 'MDV', designacao: 'Maldives', designacaoPT: 'Maldivas', nomePaisPL: 'ދިވެހިރާއްޖޭގެ ޖުމްހޫރިއްޔާ', abrevMoeda: 'MVR'},//MV
      {codigo: '454', codigoAlpha2: 'MW', codigoAlpha3: 'MWI', designacao: 'Malawi', designacaoPT: 'Malawi', nomePaisPL: 'Malawi', abrevMoeda: 'MWK'},//MW
      {codigo: '484', codigoAlpha2: 'MX', codigoAlpha3: 'MEX', designacao: 'Mexico', designacaoPT: 'México', nomePaisPL: 'Mexico', abrevMoeda: 'MXN'},//MX
      {codigo: '458', codigoAlpha2: 'MY', codigoAlpha3: 'MYS', designacao: 'Malaysia', designacaoPT: 'Malásia', nomePaisPL: 'Malaysia', abrevMoeda: 'MYR'},//MY
      {codigo: '508', codigoAlpha2: 'MZ', codigoAlpha3: 'MOZ', designacao: 'Mozambique', designacaoPT: 'Moçambique', nomePaisPL: 'Moçambique', abrevMoeda: 'MZN'},//MZ
      {codigo: '516', codigoAlpha2: 'NA', codigoAlpha3: 'NAM', designacao: 'Namibia', designacaoPT: 'Namíbia', nomePaisPL: 'Namibia', abrevMoeda: 'NAD'},//NA
      {codigo: '540', codigoAlpha2: 'NC', codigoAlpha3: 'NCL', designacao: 'New Caledonia', designacaoPT: 'Nova Caledónia', nomePaisPL: 'Nouvelle-Calédonie', abrevMoeda: 'XPF'},//NC
      {codigo: '562', codigoAlpha2: 'NE', codigoAlpha3: 'NER', designacao: 'Niger', designacaoPT: 'Níger', nomePaisPL: 'Niger', abrevMoeda: 'XOF'},//NE
      {codigo: '574', codigoAlpha2: 'NF', codigoAlpha3: 'NFK', designacao: 'Norfolk Island', designacaoPT: 'Ilha Norfolk', nomePaisPL: 'Norfolk Island', abrevMoeda: 'AUD'},//NF
      {codigo: '566', codigoAlpha2: 'NG', codigoAlpha3: 'NGA', designacao: 'Nigeria', designacaoPT: 'Nigéria', nomePaisPL: 'Nigeria', abrevMoeda: 'NGN'},//NG
      {codigo: '558', codigoAlpha2: 'NI', codigoAlpha3: 'NIC', designacao: 'Nicaragua', designacaoPT: 'Nicarágua', nomePaisPL: 'Nicaragua', abrevMoeda: 'NIO'},//NI
      {codigo: '528', codigoAlpha2: 'NL', codigoAlpha3: 'NLD', designacao: 'Netherlands', designacaoPT: 'Holanda', nomePaisPL: 'Nederland ', abrevMoeda: 'EUR'},//NL
      {codigo: '578', codigoAlpha2: 'NO', codigoAlpha3: 'NOR', designacao: 'Norway', designacaoPT: 'Noruega', nomePaisPL: 'Norge', abrevMoeda: 'NOK'},//NO
      {codigo: '524', codigoAlpha2: 'NP', codigoAlpha3: 'NPL', designacao: 'Nepal', designacaoPT: 'Nepal', nomePaisPL: 'नेपाल ', abrevMoeda: 'NPR'},//NP
      {codigo: '520', codigoAlpha2: 'NR', codigoAlpha3: 'NRU', designacao: 'Nauru', designacaoPT: 'Nauru', nomePaisPL: 'Nauru', abrevMoeda: 'AUD'},//NR
      {codigo: '570', codigoAlpha2: 'NU', codigoAlpha3: 'NIU', designacao: 'Niue', designacaoPT: 'Niue', nomePaisPL: 'Niuē', abrevMoeda: 'NZD'},//NU
      {codigo: '554', codigoAlpha2: 'NZ', codigoAlpha3: 'NZL', designacao: 'New Zealand', designacaoPT: 'Nova Zelândia', nomePaisPL: 'New Zealand', abrevMoeda: 'NZD'},//NZ
      {codigo: '512', codigoAlpha2: 'OM', codigoAlpha3: 'OMN', designacao: 'Oman', designacaoPT: 'Omã', nomePaisPL: 'عمان', abrevMoeda: 'OMR'},//OM
      {codigo: '591', codigoAlpha2: 'PA', codigoAlpha3: 'PAN', designacao: 'Panama', designacaoPT: 'Panamá', nomePaisPL: 'Panamá', abrevMoeda: 'PAB'},//PA
      {codigo: '604', codigoAlpha2: 'PE', codigoAlpha3: 'PER', designacao: 'Peru', designacaoPT: 'Peru', nomePaisPL: 'Peru', abrevMoeda: 'PEN'},//PE
      {codigo: '258', codigoAlpha2: 'PF', codigoAlpha3: 'PYF', designacao: 'French Polynesia', designacaoPT: 'Polinésia Francesa', nomePaisPL: 'Polynésie Française', abrevMoeda: 'XPF'},//PF
      {codigo: '598', codigoAlpha2: 'PG', codigoAlpha3: 'PNG', designacao: 'Papua New Guinea', designacaoPT: 'Papua-Nova Guiné', nomePaisPL: 'Papua New Guinea', abrevMoeda: 'PGK'},//PG
      {codigo: '608', codigoAlpha2: 'PH', codigoAlpha3: 'PHL', designacao: 'Philippines', designacaoPT: 'Filipinas', nomePaisPL: 'Pilipínas', abrevMoeda: 'PHP'},//PH
      {codigo: '586', codigoAlpha2: 'PK', codigoAlpha3: 'PAK', designacao: 'Pakistan', designacaoPT: 'Paquistão', nomePaisPL: 'پاكِستان', abrevMoeda: 'PKR'},//PK
      {codigo: '616', codigoAlpha2: 'PL', codigoAlpha3: 'POL', designacao: 'Poland', designacaoPT: 'Polónia', nomePaisPL: 'Polska', abrevMoeda: 'PLN'},//PL
      {
        codigo: '666',
        codigoAlpha2: 'PM',
        codigoAlpha3: 'SPM',
        designacao: 'Saint Pierre and Miquelon',
        designacaoPT: 'São Pedro e Miquelão',
        nomePaisPL: 'Saint-Pierre-et-Miquelon',
        abrevMoeda: 'EUR'
      },//PM
      {codigo: '612', codigoAlpha2: 'PN', codigoAlpha3: 'PCN', designacao: 'Pitcairn', designacaoPT: 'Ilhas Pitcairn', nomePaisPL: 'Pitcairn', abrevMoeda: 'NZD'},//PN
      {codigo: '630', codigoAlpha2: 'PR', codigoAlpha3: 'PRI', designacao: 'Puerto Rico', designacaoPT: 'Porto Rico', nomePaisPL: 'Puerto Rico', abrevMoeda: 'USD'},//PR
      {
        codigo: '275',
        codigoAlpha2: 'PS',
        codigoAlpha3: 'PSE',
        designacao: 'Palestinian Territory, Occupied',
        designacaoPT: 'Territórios Palestinianos',
        nomePaisPL: 'Palestinian Territory, Occupied',
        abrevMoeda: ''
      },//PS
      {codigo: '620', codigoAlpha2: 'PT', codigoAlpha3: 'PRT', designacao: 'Portugal', designacaoPT: 'Portugal', nomePaisPL: 'Portugal', abrevMoeda: 'EUR'},//PT
      {codigo: '585', codigoAlpha2: 'PW', codigoAlpha3: 'PLW', designacao: 'Palau', designacaoPT: 'Palau', nomePaisPL: 'Beluu er a Belau', abrevMoeda: 'USD'},//PW
      {codigo: '600', codigoAlpha2: 'PY', codigoAlpha3: 'PRY', designacao: 'Paraguay', designacaoPT: 'Paraguai', nomePaisPL: 'Paraguay', abrevMoeda: 'PYG'},//PY
      {codigo: '634', codigoAlpha2: 'QA', codigoAlpha3: 'QAT', designacao: 'Qatar', designacaoPT: 'Catar', nomePaisPL: 'قطر', abrevMoeda: 'QAR'},//QA
      {codigo: '638', codigoAlpha2: 'RE', codigoAlpha3: 'REU', designacao: 'Réunion', designacaoPT: 'Reunião', nomePaisPL: 'La Réunion', abrevMoeda: 'EUR'},//RE
      {codigo: '642', codigoAlpha2: 'RO', codigoAlpha3: 'ROU', designacao: 'Romania', designacaoPT: 'Roménia', nomePaisPL: 'România', abrevMoeda: 'RON'},//RO
      {codigo: '688', codigoAlpha2: 'RS', codigoAlpha3: 'SRB', designacao: 'Serbia', designacaoPT: 'Sérvia', nomePaisPL: 'Србија', abrevMoeda: 'RSD'},//RS
      {codigo: '643', codigoAlpha2: 'RU', codigoAlpha3: 'RUS', designacao: 'Russian Federation', designacaoPT: 'Rússia', nomePaisPL: 'Россия', abrevMoeda: 'RUB'},//RU
      {codigo: '646', codigoAlpha2: 'RW', codigoAlpha3: 'RWA', designacao: 'Rwanda', designacaoPT: 'Ruanda', nomePaisPL: 'Rwanda', abrevMoeda: 'RWF'},//RW
      {codigo: '682', codigoAlpha2: 'SA', codigoAlpha3: 'SAU', designacao: 'Saudi Arabia', designacaoPT: 'Arábia Saudita', nomePaisPL: 'السعودية', abrevMoeda: 'SAR'},//SA
      {codigo: '090', codigoAlpha2: 'SB', codigoAlpha3: 'SLB', designacao: 'Solomon Islands', designacaoPT: 'Ilhas Salomão', nomePaisPL: 'Solomon Islands', abrevMoeda: 'SBD'},//SB
      {codigo: '690', codigoAlpha2: 'SC', codigoAlpha3: 'SYC', designacao: 'Seychelles', designacaoPT: 'Seicheles', nomePaisPL: 'Seychelles', abrevMoeda: 'SCR'},//SC
      {codigo: '736', codigoAlpha2: 'SD', codigoAlpha3: 'SDN', designacao: 'Sudan', designacaoPT: 'Sudão', nomePaisPL: 'السودان', abrevMoeda: 'SDG'},//SD
      {codigo: '752', codigoAlpha2: 'SE', codigoAlpha3: 'SWE', designacao: 'Sweden', designacaoPT: 'Suécia', nomePaisPL: 'Sverige', abrevMoeda: 'SEK'},//SE
      {codigo: '702', codigoAlpha2: 'SG', codigoAlpha3: 'SGP', designacao: 'Singapore', designacaoPT: 'Singapura', nomePaisPL: 'Singapore', abrevMoeda: 'SGD'},//SG
      {
        codigo: '654',
        codigoAlpha2: 'SH',
        codigoAlpha3: 'SHN',
        designacao: 'Saint Helena, Ascension and Tristan da Cunha',
        designacaoPT: 'Santa Helena, Ascensão e Tristão da Cunha',
        nomePaisPL: 'Saint Helena, Ascension and Tristan da Cunha',
        abrevMoeda: 'SHP'
      },//SH
      {codigo: '705', codigoAlpha2: 'SI', codigoAlpha3: 'SVN', designacao: 'Slovenia', designacaoPT: 'Eslovénia', nomePaisPL: 'Slovenija', abrevMoeda: 'EUR'},//SI
      {
        codigo: '744',
        codigoAlpha2: 'SJ',
        codigoAlpha3: 'SJM',
        designacao: 'Svalbard and Jan Mayen',
        designacaoPT: 'Svalbard e Jan Mayen',
        nomePaisPL: 'Svalbard og Jan Mayen',
        abrevMoeda: 'NOK'
      },//SJ
      {codigo: '703', codigoAlpha2: 'SK', codigoAlpha3: 'SVK', designacao: 'Slovakia', designacaoPT: 'Eslováquia', nomePaisPL: 'Slovensko', abrevMoeda: 'EUR'},//SK
      {codigo: '694', codigoAlpha2: 'SL', codigoAlpha3: 'SLE', designacao: 'Sierra Leone', designacaoPT: 'Serra Leoa', nomePaisPL: 'Sierra Leone', abrevMoeda: 'SLL'},//SL
      {codigo: '674', codigoAlpha2: 'SM', codigoAlpha3: 'SMR', designacao: 'San Marino', designacaoPT: 'São Marino', nomePaisPL: 'San Marino', abrevMoeda: 'EUR'},//SM
      {codigo: '686', codigoAlpha2: 'SN', codigoAlpha3: 'SEN', designacao: 'Senegal', designacaoPT: 'Senegal', nomePaisPL: 'Le Sénégal', abrevMoeda: 'XOF'},//SN
      {codigo: '706', codigoAlpha2: 'SO', codigoAlpha3: 'SOM', designacao: 'Somalia', designacaoPT: 'Somália', nomePaisPL: 'Soomaaliya', abrevMoeda: 'SOS'},//SO
      {codigo: '740', codigoAlpha2: 'SR', codigoAlpha3: 'SUR', designacao: 'Suriname', designacaoPT: 'Suriname', nomePaisPL: 'Suriname', abrevMoeda: 'SRD'},//SR
      {
        codigo: '678',
        codigoAlpha2: 'ST',
        codigoAlpha3: 'STP',
        designacao: 'Sao Tome and Principe',
        designacaoPT: 'São Tomé e Príncipe',
        nomePaisPL: 'São Tomé e Príncipe',
        abrevMoeda: 'STD'
      },//ST
      {codigo: '222', codigoAlpha2: 'SV', codigoAlpha3: 'SLV', designacao: 'El Salvador', designacaoPT: 'Salvador', nomePaisPL: 'El Salvador', abrevMoeda: 'SVC'},//SV
      {codigo: '760', codigoAlpha2: 'SY', codigoAlpha3: 'SYR', designacao: 'Syrian Arab Republic', designacaoPT: 'Síria', nomePaisPL: 'سوريا', abrevMoeda: 'SYP'},//SY
      {codigo: '748', codigoAlpha2: 'SZ', codigoAlpha3: 'SWZ', designacao: 'Swaziland', designacaoPT: 'Suazilândia', nomePaisPL: 'Umbuso weSwatini', abrevMoeda: 'SZL'},//SZ
      {
        codigo: '796',
        codigoAlpha2: 'TC',
        codigoAlpha3: 'TCA',
        designacao: 'Turks and Caicos Islands',
        designacaoPT: 'Turcas e Caicos',
        nomePaisPL: 'Turks and Caicos Islands',
        abrevMoeda: 'USD'
      },//TC
      {codigo: '148', codigoAlpha2: 'TD', codigoAlpha3: 'TCD', designacao: 'Chad', designacaoPT: 'Chade', nomePaisPL: 'تشاد', abrevMoeda: 'XAF'},//TD
      {
        codigo: '260',
        codigoAlpha2: 'TF',
        codigoAlpha3: 'ATF',
        designacao: 'French Southern Territories',
        designacaoPT: 'Terras Austrais e Antárticas Francesas',
        nomePaisPL: 'Terres Australes et Antarctiques Françaises',
        abrevMoeda: 'EUR'
      },//TF
      {codigo: '768', codigoAlpha2: 'TG', codigoAlpha3: 'TGO', designacao: 'Togo', designacaoPT: 'Togo', nomePaisPL: 'Togo', abrevMoeda: 'XOF'},//TG
      {codigo: '764', codigoAlpha2: 'TH', codigoAlpha3: 'THA', designacao: 'Thailand', designacaoPT: 'Tailândia', nomePaisPL: 'ประเทศไทย', abrevMoeda: 'THB'},//TH
      {codigo: '762', codigoAlpha2: 'TJ', codigoAlpha3: 'TJK', designacao: 'Tajikistan', designacaoPT: 'Tajiquistão', nomePaisPL: 'Тоҷикистон', abrevMoeda: 'TJS'},//TJ
      {codigo: '772', codigoAlpha2: 'TK', codigoAlpha3: 'TKL', designacao: 'Tokelau', designacaoPT: 'Toquelau', nomePaisPL: 'Tokelau', abrevMoeda: 'NZD'},//TK
      {codigo: '626', codigoAlpha2: 'TL', codigoAlpha3: 'TLS', designacao: 'Timor-Leste', designacaoPT: 'Timor-Leste', nomePaisPL: 'Timor-Leste', abrevMoeda: 'USD'},//TL
      {codigo: '795', codigoAlpha2: 'TM', codigoAlpha3: 'TKM', designacao: 'Turkmenistan', designacaoPT: 'Turquemenistão', nomePaisPL: 'Türkmenistan', abrevMoeda: 'TMT'},//TM
      {codigo: '788', codigoAlpha2: 'TN', codigoAlpha3: 'TUN', designacao: 'Tunisia', designacaoPT: 'Tunísia', nomePaisPL: 'تونس', abrevMoeda: 'TND'},//TN
      {codigo: '776', codigoAlpha2: 'TO', codigoAlpha3: 'TON', designacao: 'Tonga', designacaoPT: 'Tonga', nomePaisPL: 'Tonga', abrevMoeda: 'TOP'},//TO
      {codigo: '792', codigoAlpha2: 'TR', codigoAlpha3: 'TUR', designacao: 'Turkey', designacaoPT: 'Turquia', nomePaisPL: 'Türkiye', abrevMoeda: 'TRY'},//TR
      {
        codigo: '780',
        codigoAlpha2: 'TT',
        codigoAlpha3: 'TTO',
        designacao: 'Trinidad and Tobago',
        designacaoPT: 'Trindade e Tobago',
        nomePaisPL: 'Trinidad and Tobago',
        abrevMoeda: 'TTD'
      },//TT
      {codigo: '798', codigoAlpha2: 'TV', codigoAlpha3: 'TUV', designacao: 'Tuvalu', designacaoPT: 'Tuvalu', nomePaisPL: 'Tuvalu', abrevMoeda: 'TVD'},//TV
      {codigo: '158', codigoAlpha2: 'TW', codigoAlpha3: 'TWN', designacao: 'Taiwan, Province of China', designacaoPT: 'Taiwan', nomePaisPL: '臺灣', abrevMoeda: 'TWD'},//TW
      {codigo: '834', codigoAlpha2: 'TZ', codigoAlpha3: 'TZA', designacao: 'Tanzania, United Republic of', designacaoPT: 'Tanzânia', nomePaisPL: 'Tanzania', abrevMoeda: 'TZS'},//TZ
      {codigo: '804', codigoAlpha2: 'UA', codigoAlpha3: 'UKR', designacao: 'Ukraine', designacaoPT: 'Ucrânia', nomePaisPL: 'Україна', abrevMoeda: 'UAH'},//UA
      {codigo: '800', codigoAlpha2: 'UG', codigoAlpha3: 'UGA', designacao: 'Uganda', designacaoPT: 'Uganda', nomePaisPL: 'Uganda', abrevMoeda: 'UGX'},//UG
      {
        codigo: '581',
        codigoAlpha2: 'UM',
        codigoAlpha3: 'UMI',
        designacao: 'United States Minor Outlying Islands',
        designacaoPT: 'Ilhas Menores Distantes dos Estados Unidos',
        nomePaisPL: 'United States Minor Outlying Islands',
        abrevMoeda: 'USD'
      },//UM
      {
        codigo: '840',
        codigoAlpha2: 'US',
        codigoAlpha3: 'USA',
        designacao: 'United States',
        designacaoPT: 'Estados Unidos da América',
        nomePaisPL: 'United States of America',
        abrevMoeda: 'USD'
      },//US
      {codigo: '858', codigoAlpha2: 'UY', codigoAlpha3: 'URY', designacao: 'Uruguay', designacaoPT: 'Uruguai', nomePaisPL: 'Uruguay', abrevMoeda: 'UYU'},//UY
      {codigo: '860', codigoAlpha2: 'UZ', codigoAlpha3: 'UZB', designacao: 'Uzbekistan', designacaoPT: 'Usbequistão', nomePaisPL: 'O‘zbekiston', abrevMoeda: 'UZS'},//UZ
      {
        codigo: '336',
        codigoAlpha2: 'VA',
        codigoAlpha3: 'VAT',
        designacao: 'Holy See (Vatican City State)',
        designacaoPT: 'Estado da Cidade do Vaticano',
        nomePaisPL: 'Stato della Città del Vaticano',
        abrevMoeda: 'EUR'
      },//VA
      {
        codigo: '670',
        codigoAlpha2: 'VC',
        codigoAlpha3: 'VCT',
        designacao: 'Saint Vincent and the Grenadines',
        designacaoPT: 'São Vicente e Granadinas',
        nomePaisPL: 'Saint Vincent and the Grenadines',
        abrevMoeda: 'XCD'
      },//VC
      {codigo: '862', codigoAlpha2: 'VE', codigoAlpha3: 'VEN', designacao: 'Venezuela, Bolivarian Republic of', designacaoPT: 'Venezuela', nomePaisPL: 'Venezuela', abrevMoeda: 'VEF'},//VE
      {
        codigo: '092',
        codigoAlpha2: 'VG',
        codigoAlpha3: 'VGB',
        designacao: 'Virgin Islands, British',
        designacaoPT: 'Ilhas Virgens Britânicas',
        nomePaisPL: 'Virgin Islands, British',
        abrevMoeda: 'USD'
      },//VG
      {
        codigo: '850',
        codigoAlpha2: 'VI',
        codigoAlpha3: 'VIR',
        designacao: 'Virgin Islands, U.S.',
        designacaoPT: 'Ilhas Virgens Americanas',
        nomePaisPL: 'Virgin Islands, U.S.',
        abrevMoeda: 'USD'
      },//VI
      {codigo: '704', codigoAlpha2: 'VN', codigoAlpha3: 'VNM', designacao: 'Viet Nam', designacaoPT: 'Vietname', nomePaisPL: 'Việt Nam', abrevMoeda: 'VND'},//VN
      {codigo: '548', codigoAlpha2: 'VU', codigoAlpha3: 'VUT', designacao: 'Vanuatu', designacaoPT: 'Vanuatu', nomePaisPL: 'Vanuatu', abrevMoeda: 'VUV'},//VU
      {codigo: '876', codigoAlpha2: 'WF', codigoAlpha3: 'WLF', designacao: 'Wallis and Futuna', designacaoPT: 'Wallis e Futuna', nomePaisPL: 'Wallis et Futuna', abrevMoeda: 'XPF'},//WF
      {codigo: '882', codigoAlpha2: 'WS', codigoAlpha3: 'WSM', designacao: 'Samoa', designacaoPT: 'Samoa', nomePaisPL: 'Sāmoa', abrevMoeda: 'WST'},//WS
      {codigo: '887', codigoAlpha2: 'YE', codigoAlpha3: 'YEM', designacao: 'Yemen', designacaoPT: 'Iémen', nomePaisPL: 'الجمهورية اليمنية', abrevMoeda: 'YER'},//YE
      {codigo: '175', codigoAlpha2: 'YT', codigoAlpha3: 'MYT', designacao: 'Mayotte', designacaoPT: 'Maiote', nomePaisPL: 'Mayotte', abrevMoeda: 'EUR'},//YT
      {codigo: '710', codigoAlpha2: 'ZA', codigoAlpha3: 'ZAF', designacao: 'South Africa', designacaoPT: 'África do Sul', nomePaisPL: 'South Africa', abrevMoeda: 'ZAR'},//ZA
      {codigo: '894', codigoAlpha2: 'ZM', codigoAlpha3: 'ZMB', designacao: 'Zambia', designacaoPT: 'Zâmbia', nomePaisPL: 'Zambia', abrevMoeda: 'ZMW'},//ZM
      {codigo: '716', codigoAlpha2: 'ZW', codigoAlpha3: 'ZWE', designacao: 'Zimbabwe', designacaoPT: 'Zimbabué', nomePaisPL: 'Zimbabwe', abrevMoeda: 'ZWD'}//ZM
      // jshint ignore:end
    ]);
})();
